<style>
.SessionlistMultitracker.session-list-wrapper {
  margin-left: 0;
}
/* .SessionlistMultitracker.session-list-wrapper > .container-fluid {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
} */
.session-head-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.session-head-wrap h1.page-head {
  margin-bottom: 0;
}
.session-head-tab-wrapper button.common-tab-button {
  width: 120px;
  padding: 6px 0;
  font-size: 14px;
  font-weight: 600;
  background: #fff;
  border: 1px solid #000;
}
.session-head-tab-wrapper button.common-tab-button.border-left-radius {
  border-radius: 5px 0 0 5px;
  border-right: none;
}
.session-head-tab-wrapper button.common-tab-button.border-right-radius {
  border-radius: 0px 5px 5px 0px;
  border-left: none;
}
.session-head-tab-wrapper button.common-tab-button.active-btn {
  background: #000;
  color: #fff;
}
.session-link {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.session-type-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 40px;
  overflow: hidden;
}
.session-type-icon img {
  max-width: 100%;
  max-height: 100%;
}
.session-details .session-live-des #dvBroadcast li label img {
  -webkit-filter: none;
  filter: none;
}

.session-details .session-live-des #dvBroadcast a.upcoming-status {
  background: #ddd;
}

/****session****/
.SessionlistMultitracker .four-track .track-box {
  width: 24%;
  float: left;
}
.flex-wrap-four {
  flex-wrap: wrap;
}
.flex-wrap-four .row.main-divider.main-divider-continue {
  margin-top: 60px !important;
}
.main-divider-continue {
  position: relative !important;
}

.two-session #dvBroadcast {
  justify-content: flex-end;
}
.two-session .icon-bookmark1.bmark-pupupbtn {
  margin: 0 !important;
}

.flex-wrap-four .row.main-divider.main-divider-continue .track-headding {
  padding-left: 0;
}
.flex-wrap-four .row.main-divider.main-divider-continue .white-b-wrapper {
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 1px 6px 0 rgb(28 28 28 / 10%);
}
.flex-wrap-four .row.main-divider.main-divider-continue .white-b-wrapper:hover {
  box-shadow: 0 1px 6px 0 rgb(0 0 0 / 50%);
}

.track-box-continue {
  position: relative;
  width: 100%;
  background-color: #d7d7ea;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.track-box.track-box-continue:empty {
  background: transparent !important;
  background-color: transparent !important;
}
.visibility-hidden {
  visibility: hidden;
}
.retry-modal {
  text-align: center;
}
.retry-modal .button-no {
  padding: 10px 30px;
  border-radius: 5px;
  color: #1e1f26;
  background: #eee;
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
  margin-top: 20px;
  margin-right: 10px;
}
.retry-modal .button-yes {
  padding: 10px 30px;
  border-radius: 5px;
  color: #fff;
  background: #0b8a20;
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
  margin-top: 20px;
}
.mobile-session-dropdown {
  display: none;
}
.new-btn-design {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-left: 15px;
  padding: 8px 12px 8px 0;
  min-width: auto;
  /* background: #19a883; */
  /* background: #4FBE45; */
  background: #28a745;
  border-radius: 5px;
}
.new-btn-design img {
  border-right: 1px solid rgba(255, 255, 255, 0.4);
  padding: 0 12px;
}
.new-btn-design span {
  color: #fff;
  font-weight: 600 !important;
  font-size: 14px !important;
  margin-left: 10px !important;
}
.new-btn-design-disabled {
  opacity: 1;
  background: #d4d6d7 !important;
}
.three-session #dvBroadcast {
  justify-content: flex-start;
}
.three-session .new-btn-design {
  margin: 0 !important;
}
.col-12.pl-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.v-application p {
  margin: unset;
}
.v-application ol,
.v-application ul {
  padding: 0 !important;
}
.on-demand-session-option {
  position: relative;
}
.on-demand-session-option p {
  margin: 0 0 0 2px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  padding: 0 4px;
}
.on-demand-session-option p span {
  height: 6px;
  width: 6px;
  background: #333;
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;
  margin: 2px;
}
.on-demand-dropdown {
  position: absolute;
  right: 4px;
  bottom: 100%;
  min-width: 169px;
  background: #fff;
  min-height: 41px;
  padding: 0 15px;
  border-radius: 6px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  z-index: 999999;
  margin-bottom: 15px;
}
/*.on-demand-dropdown:before {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-bottom: 10px solid #fff;
    bottom: 100%;
    left: auto;
    right: 11px;
    box-shadow: 0 0 5px rgb(0 0 0 / 20%); 
     overflow: hidden; 
}*/
.on-demand-dropdown ul {
  margin: 0;
  padding: 0;
}
.on-demand-dropdown ul li {
  list-style: none;
  font-size: 0.875rem;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
  font-weight: 400;
  cursor: pointer;
}
.on-demand-dropdown ul li:last-child {
  border-bottom: none;
}
/*------------------------------------------*/
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .tooltip.show {
    display: none;
  }
  .new-btn-design {
    min-width: auto;
  }
  .three-session .new-btn-design {
    width: auto;
  }
  .two-session .new-btn-design {
    width: auto;
  }
}

.session-time-zone {
  text-align: left;
  color: #8b8b8b;
  position: relative; /* anchors the ::before icon */
  padding-left: 22px; /* reserves space for the icon */
  display: inline-flex;
  align-items: center;
}
.session-time-zone:before {
  content: "\f0ac"; /* FontAwesome globe glyph */
  font: normal normal normal 14px/1 FontAwesome, "Font Awesome 5 Free";
  position: absolute; /* needed for top/left to apply */
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  color: currentColor; /* match the time-zone text color */
}
.SessionlistMultitracker .two-session .main-divider-wrap {
  width: 49%;
  float: left;
}

.SessionlistMultitracker .main-divider {
  /*width: 100% !important;*/
}
.nav.nav-tabs.session-nav-tab {
  border-bottom: none;
  gap: 8px;
}
.nav.nav-tabs.session-nav-tab .nav-item .nav-link {
  color: #fff !important;
  background-color: #4a3f37;
  opacity: 0.9;
  border: 1px solid #4a3f37;
  border-radius: 999px;
  padding: 6px 18px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none !important;
  transition: all 0.2s ease;
}
.nav.nav-tabs.session-nav-tab .nav-item .nav-link.active {
  color: #1c1d26 !important;
  background: #fff;
  border-color: #fff;
  text-decoration: none !important;
}
.nav.nav-tabs.session-nav-tab .nav-item .nav-link::after,
.nav.nav-tabs.session-nav-tab .nav-item .nav-link.active::after {
  display: none !important;
  content: none !important;
}
@media only screen and (max-width: 767px) {
  .new-btn-design {
    min-width: auto;
  }
  .three-session .new-btn-design {
    width: auto;
  }
  .two-session .new-btn-design {
    width: auto;
  }

  .mobile-session-dropdown {
    display: block;
  }
  .mobile-session-dropdown select {
    width: 100%;
    height: 40px;
    border: 1px solid #dfdfdf;
    padding: 0 20px 0 15px;
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    -moz-appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    background: #fff url(../assets/Images/icons/down-arrow-black.svg) no-repeat
      scroll right 12px center / 20px;
    margin-bottom: 15px;
  }
  .mobile-session-dropdown select:focus {
    outline: none !important;
  }
  /* .web-session-tab {
    display: none;
  } */

  .SessionlistMultitracker #dvBroadcast a.schedule-speaker {
    margin-right: 0 !important;
  }

  .plus-circle {
    display: none;
  }

  .new-btn-design img {
    height: 21px;
    width: 48px;
  }
  .session-head-wrap {
    flex-direction: column;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape) {
  .plus-circle {
    display: none;
  }
  .SessionlistMultitracker #dvBroadcast a.schedule-speaker {
    margin-right: 0 !important;
    display: none;
  }
  .tooltip.show {
    display: none;
  }
  .new-btn-design img {
    height: 21px;
    width: 48px;
  }
}
.player-wrapper-hld.body-content {
  padding: 0px 0;
}

/* =====================================================================
   Sessions page - Figma design parity
   Reference: https://www.figma.com/design/xvTUgExIDj1x38JzYPdjnU/Web-Spiders-Design-Elements?node-id=36067-3777
   Spec: container 1220px, card padding 27px 30px, border-radius 14px,
   drop-shadow 0 3px 1.5px rgba(0,0,0,.12), gap 14px between cards,
   gap 20px between tabs row and card list, gap 6px between date tabs.
===================================================================== */
@media only screen and (min-width: 768px) {
  /* 1220px main container with breathing room on tablet widths so the
     cards don't touch the viewport edge below 1280px. */
  .SessionlistMultitracker.session-list-wrapper > .container-fluid {
    max-width: 1220px !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
  @media (min-width: 1280px) {
    .SessionlistMultitracker.session-list-wrapper > .container-fluid {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
  .SessionlistMultitracker .session-tab-wrapper {
    margin-top: 20px !important;
  }
  .SessionlistMultitracker .session-tab-wrapper > div[style*="width: 100%"] {
    margin-bottom: 20px;
  }

  /* ---------------------------------------------------------------------
     Card layout: switch from the legacy absolute-positioned time column
     (`.time-location { position: absolute; left: -122px; width: 110px }`
     paired with `.white-box-wrapper { margin-left: 120px }`) to a flat
     flex row inside the card:

         [ time (70px) ][ gap 60px ][ status + title ][ on demand btn ]

     This eliminates the negative-left positioning trick, so the card
     hugs its own bounds and the time stays inside, regardless of the
     container's left edge.
  --------------------------------------------------------------------- */
  .SessionlistMultitracker.session-list-wrapper .white-box-wrapper {
    margin-left: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 60px;
    /* Fixed card height 100px, vertical padding 0 - flex centering does
       the alignment so all three columns sit on the card's vertical
       midline regardless of their intrinsic height. */
    height: 100px !important;
    min-height: 100px;
    padding: 0 30px !important;
    box-sizing: border-box !important;
  }
  .SessionlistMultitracker .white-box-wrapper .time-location {
    position: static !important;
    width: 70px !important;
    min-width: 70px !important;
    height: auto !important;
    left: auto !important;
    top: auto !important;
    bottom: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    background: transparent !important;
    border-radius: 0 !important;
    text-align: left !important;
    display: flex !important;
    align-items: center !important;
    flex-shrink: 0;
  }
  .SessionlistMultitracker .white-box-wrapper .time-location ul {
    margin: 0 !important;
    padding: 0 !important;
    list-style: none !important;
    width: 100%;
  }
  /* Time text contains "11:30 PM <br/> 11:59 PM". The <br> gives the
     line break naturally; nowrap on the span stops the space inside
     each time string from wrapping ("11:30 PM" stays one line). */
  .SessionlistMultitracker .white-box-wrapper .time-location ul li span {
    display: block !important;
    font-family: "Inter", sans-serif;
    font-size: 16px !important;
    font-weight: 500 !important;
    line-height: 24px !important;
    color: #000000 !important;
    white-space: nowrap !important;
  }
  /* Right column (speakers + button) - hug content, never escape the
     card. `position: static` + zero offsets + no margin overrides any
     absolute/negative-margin styling on parents that would push the
     button past the card's right edge. */
  .SessionlistMultitracker .white-box-wrapper .right-area-hld {
    position: static !important;
    padding: 0 !important;
    margin: 0 !important;
    right: auto !important;
    top: auto !important;
    height: auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 12px;
    flex-shrink: 0;
  }
  .SessionlistMultitracker .white-box-wrapper #dvBroadcast {
    position: static !important;
    margin: 0 !important;
    padding: 0 !important;
    right: auto !important;
    top: auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 12px;
  }
  /* Button itself - clamp to card content area, never bleed past 30px
     right padding (which is already on .white-box-wrapper above). */
  .SessionlistMultitracker .white-box-wrapper a.icon-bookmark1,
  .SessionlistMultitracker .white-box-wrapper .bmark-pupupbtn.new-btn-design {
    position: static !important;
    margin: 0 !important;
    right: auto !important;
    flex-shrink: 0;
    white-space: nowrap;
  }
  /* Middle column (status + title) - flex-grow to take remaining space */
  .SessionlistMultitracker .white-box-wrapper .main-divider-wrap {
    flex: 1 1 auto;
    min-width: 0;
  }
  /* The Bootstrap row inside the card (.main-divider /
     .main-divider-continue) must be flex-row so left col (status +
     title) and right col (speakers + button) sit side by side. */
  .SessionlistMultitracker .white-box-wrapper .main-divider,
  .SessionlistMultitracker .white-box-wrapper .main-divider-continue {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    flex-wrap: nowrap !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    float: none !important;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  .SessionlistMultitracker .white-box-wrapper .main-divider > [class*="col-"],
  .SessionlistMultitracker
    .white-box-wrapper
    .main-divider-continue
    > [class*="col-"] {
    padding-left: 0 !important;
    padding-right: 0 !important;
    flex: 1 1 auto !important;
    max-width: none !important;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    margin-bottom: 0;
  }
  /* .SessionlistMultitracker
    .white-box-wrapper
    .main-divider
    > [class*="col-"]:last-child,
  .SessionlistMultitracker
    .white-box-wrapper
    .main-divider-continue
    > [class*="col-"]:last-child {
    flex: 0 0 auto !important;
  } */
  /* Reset every inner block that historically painted its own card
     edge - this is what was creating the "card inside a card" look. */
  .SessionlistMultitracker .white-box-wrapper .left-area-hld,
  .SessionlistMultitracker .white-box-wrapper .right-area-hld,
  .SessionlistMultitracker .white-box-wrapper .multimple-tracker,
  .SessionlistMultitracker .white-box-wrapper #dvBroadcast {
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  .SessionlistMultitracker .white-box-wrapper .left-area-hld {
    padding: 0 !important;
    height: auto !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  .SessionlistMultitracker .white-box-wrapper .session-status {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* ---------------------------------------------------------------------
     Multi-agenda rows (.two-session / .three-session / .four-session):
     a single white-box-wrapper holds the shared time column plus 2-4
     session blocks. The single-session height (100px) and the
     horizontal left/button row inside each .main-divider don't fit
     when divided across multiple sessions, so we override:

       - card height: auto (taller than 100px to fit stacked content)
       - flex gap between sessions: 24px (down from 60px)
       - inside each session block: title + meta on top, button below
         (vertical column instead of horizontal row)
  --------------------------------------------------------------------- */
  .SessionlistMultitracker .white-box-wrapper.two-session,
  .SessionlistMultitracker .white-box-wrapper.three-session,
  .SessionlistMultitracker .white-box-wrapper.four-session {
    height: auto !important;
    min-height: 100px !important;
    padding: 20px 30px !important;
    gap: 24px !important;
    align-items: stretch !important;
  }
  .SessionlistMultitracker .white-box-wrapper.two-session .time-location,
  .SessionlistMultitracker .white-box-wrapper.three-session .time-location,
  .SessionlistMultitracker .white-box-wrapper.four-session .time-location {
    align-self: center;
  }
  /* Each session block inside the multi-row is its own flex column */
  .SessionlistMultitracker .white-box-wrapper.two-session .main-divider-wrap,
  .SessionlistMultitracker .white-box-wrapper.three-session .main-divider-wrap,
  .SessionlistMultitracker .white-box-wrapper.four-session .main-divider-wrap {
    flex: 1 1 0 !important;
    min-width: 0;
    float: none !important;
    width: auto !important;
  }
  /* Stack the (status + title) and (button) of each session vertically
     so the button never overflows when horizontal space is tight. */
  .SessionlistMultitracker .white-box-wrapper.two-session .main-divider,
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    .main-divider-continue,
  .SessionlistMultitracker .white-box-wrapper.three-session .main-divider,
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    .main-divider-continue,
  .SessionlistMultitracker .white-box-wrapper.four-session .main-divider,
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    .main-divider-continue {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
    width: 100% !important;
  }
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    .main-divider
    > [class*="col-"],
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    .main-divider
    > [class*="col-"],
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    .main-divider
    > [class*="col-"] {
    flex: 0 0 auto !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .SessionlistMultitracker .white-box-wrapper.two-session .right-area-hld,
  .SessionlistMultitracker .white-box-wrapper.three-session .right-area-hld,
  .SessionlistMultitracker .white-box-wrapper.four-session .right-area-hld {
    justify-content: flex-start !important;
  }
  /* The action button lives inside #dvBroadcast which was set to
     justify-content: flex-end for single-session (button hugs the
     card's right edge). In a multi-session card each session is its
     own column under a title, so the button must align flush-left
     with that title rather than drifting to the far right of the
     column. Override #dvBroadcast inside multi-session rows only. */
  .SessionlistMultitracker .white-box-wrapper.two-session #dvBroadcast,
  .SessionlistMultitracker .white-box-wrapper.three-session #dvBroadcast,
  .SessionlistMultitracker .white-box-wrapper.four-session #dvBroadcast {
    justify-content: flex-start !important;
  }
  /* Track header (when the row has track names per session) keeps its
     row above the session block, full width inside the column. */
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    .track-box.track-box-continue,
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    .track-box.track-box-continue,
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    .track-box.track-box-continue {
    width: 100%;
    margin-bottom: 6px;
  }

  /* =====================================================================
     Multi-session row: split into separate per-session cards.
     The parent .white-box-wrapper becomes a transparent flex row that
     just lays out children with a gap. Each .main-divider-wrap inside
     becomes its own white card with its own time column on the left
     (rendered by the v-if="sessionRow.RowSessionCount > 1" block in
     the template).
  ===================================================================== */
  .SessionlistMultitracker .white-box-wrapper.two-session,
  .SessionlistMultitracker .white-box-wrapper.three-session,
  .SessionlistMultitracker .white-box-wrapper.four-session,
  .SessionlistMultitracker.session-list-wrapper .white-box-wrapper.two-session,
  .SessionlistMultitracker.session-list-wrapper
    .white-box-wrapper.three-session,
  .SessionlistMultitracker.session-list-wrapper
    .white-box-wrapper.four-session {
    background: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
    border: 0 !important;
    border-radius: 0 !important;
    padding: 0 !important;
    margin-bottom: 14px !important;
    overflow: visible;
    /* Grid layout: column 1 = shared time card (compact 96px), columns
       2-3 = sessions laid out 2 per row. The shared time card spans
       every row so it's visually clear that every session in the row
       shares this slot. */
    display: grid !important;
    grid-template-columns: 96px 1fr 1fr !important;
    grid-auto-rows: auto !important;
    gap: 14px !important;
    align-items: stretch !important;
  }
  .SessionlistMultitracker .white-box-wrapper.two-session:hover,
  .SessionlistMultitracker .white-box-wrapper.three-session:hover,
  .SessionlistMultitracker .white-box-wrapper.four-session:hover {
    box-shadow: none !important;
  }
  /* Shared time card on the left - spans every row so it's clear the
     sessions next to it all start at this time. Restyled as its own
     compact white card.

     grid-row needs to be set per session count because the generic
     `1 / -1` isn't reliable with grid-auto-rows in every browser:
       - .two-session  -> 1 session row, so the default 1-row span fits
       - .three-session -> 2 rows in the grid (3 sessions / 2 cols)
       - .four-session  -> 2 rows in the grid (4 sessions / 2 cols)
  */
  .SessionlistMultitracker .white-box-wrapper.two-session > .time-location,
  .SessionlistMultitracker .white-box-wrapper.three-session > .time-location,
  .SessionlistMultitracker .white-box-wrapper.four-session > .time-location {
    display: flex !important;
    align-items: center;
    justify-content: center;
    grid-column: 1;
    grid-row: 1;
    background: #ffffff !important;
    border-radius: 14px !important;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.12) !important;
    padding: 14px 10px !important;
    position: static !important;
    width: auto !important;
    left: auto !important;
    min-width: 0;
    align-self: stretch;
  }
  .SessionlistMultitracker .white-box-wrapper.three-session > .time-location,
  .SessionlistMultitracker .white-box-wrapper.four-session > .time-location {
    grid-row: 1 / span 2 !important;
  }
  .SessionlistMultitracker .white-box-wrapper.two-session > .time-location ul,
  .SessionlistMultitracker .white-box-wrapper.three-session > .time-location ul,
  .SessionlistMultitracker .white-box-wrapper.four-session > .time-location ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    > .time-location
    ul
    li,
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    > .time-location
    ul
    li,
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    > .time-location
    ul
    li {
    list-style: none;
  }
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    > .time-location
    ul
    li
    span,
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    > .time-location
    ul
    li
    span,
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    > .time-location
    ul
    li
    span {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    color: #1a1a1a;
    white-space: nowrap;
    text-align: center;
    display: block;
  }
  /* Each session block becomes a standalone card */
  .SessionlistMultitracker .white-box-wrapper.two-session .main-divider-wrap,
  .SessionlistMultitracker .white-box-wrapper.three-session .main-divider-wrap,
  .SessionlistMultitracker .white-box-wrapper.four-session .main-divider-wrap {
    background: #ffffff !important;
    border-radius: 14px !important;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.12) !important;
    padding: 20px 24px !important;
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 24px !important;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    min-height: 100px;
  }
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    .main-divider-wrap:hover,
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    .main-divider-wrap:hover,
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    .main-divider-wrap:hover {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.14) !important;
  }
  /* The session content column (status + title + button) takes the rest */
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    .main-divider-wrap
    > .main-divider,
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    .main-divider-wrap
    > .main-divider-continue,
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    .main-divider-wrap
    > .main-divider,
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    .main-divider-wrap
    > .main-divider-continue,
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    .main-divider-wrap
    > .main-divider,
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    .main-divider-wrap
    > .main-divider-continue {
    flex: 1 1 auto !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: space-between !important;
    margin: 0 !important;
    width: auto !important;
  }
  /* Inside each card, left col (status + title) sits next to button */
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    .main-divider-wrap
    > .main-divider
    > [class*="col-"]:first-child,
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    .main-divider-wrap
    > .main-divider
    > [class*="col-"]:first-child,
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    .main-divider-wrap
    > .main-divider
    > [class*="col-"]:first-child {
    flex: 1 1 auto !important;
    width: auto !important;
    max-width: none !important;
  }
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    .main-divider-wrap
    > .main-divider
    > [class*="col-"]:last-child,
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    .main-divider-wrap
    > .main-divider
    > [class*="col-"]:last-child,
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    .main-divider-wrap
    > .main-divider
    > [class*="col-"]:last-child {
    flex: 0 0 auto !important;
    width: auto !important;
    max-width: none !important;
    margin-left: auto;
  }
  /* Action button hugs right edge inside its card */
  .SessionlistMultitracker
    .white-box-wrapper.two-session
    .main-divider-wrap
    #dvBroadcast,
  .SessionlistMultitracker
    .white-box-wrapper.three-session
    .main-divider-wrap
    #dvBroadcast,
  .SessionlistMultitracker
    .white-box-wrapper.four-session
    .main-divider-wrap
    #dvBroadcast {
    justify-content: flex-end !important;
  }

  /* Date tab pills (Figma: rgba(0,0,0,.5) + backdrop-blur, 46px radius) */
  .nav.nav-tabs.session-nav-tab {
    gap: 6px !important;
    border-bottom: none;
    padding: 0;
  }
  .nav.nav-tabs.session-nav-tab .nav-item .nav-link {
    background-color: rgba(0, 0, 0, 0.5) !important;
    backdrop-filter: blur(7px);
    -webkit-backdrop-filter: blur(7px);
    color: #ffffff !important;
    border: 0 !important;
    border-radius: 46px !important;
    padding: 8px 19px !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    line-height: 24px !important;
    font-family: "Inter", sans-serif;
    cursor: pointer;
    text-decoration: none !important;
    transition: background-color 0.2s ease, color 0.2s ease;
  }
  .nav.nav-tabs.session-nav-tab .nav-item .nav-link:hover {
    background-color: rgba(0, 0, 0, 0.7) !important;
    color: #ffffff !important;
  }
  .nav.nav-tabs.session-nav-tab .nav-item .nav-link.active,
  .nav.nav-tabs.session-nav-tab .nav-item .nav-link.active:hover {
    background-color: #ffffff !important;
    color: #000000 !important;
    backdrop-filter: none;
  }

  /* Session card - Figma spec
     box-shadow per Figma: 0 3px 3px 0 rgba(0,0,0,0.12) */
  .SessionlistMultitracker .session-list-wrapper .white-box-wrapper,
  .session-list-wrapper.SessionlistMultitracker .white-box-wrapper,
  .SessionlistMultitracker .white-box-wrapper {
    background: #ffffff !important;
    border: 0 !important;
    border-radius: 14px !important;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.12) !important;
    margin-bottom: 14px !important;
    margin-left: 0 !important;
    /* overflow:visible so the highlight ring on the first upcoming
       card can render at the edge without being clipped */
    overflow: visible;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    position: relative;
  }
  .SessionlistMultitracker .white-box-wrapper:hover {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.14) !important;
  }
  /* The card list container also must allow the 3px outer ring to show */
  .SessionlistMultitracker #dvMainTabContent,
  .SessionlistMultitracker .tab-pane1 {
    overflow: visible !important;
  }

  /* Card padding is now on .white-box-wrapper itself (see flex block
     above). Inner .left-area-hld and .right-area-hld are flex children
     with zero padding so they sit at the card's content edge. */

  /* Status row: dot + "Upcoming" 16px #7c8088 */
  .SessionlistMultitracker .white-box-wrapper .session-status p {
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: "Inter", sans-serif;
    font-size: 16px !important;
    font-weight: 500 !important;
    line-height: 16px !important;
    color: #7c8088 !important;
    margin: 0;
  }
  .SessionlistMultitracker .white-box-wrapper .session-status p span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
  }
  .SessionlistMultitracker
    .white-box-wrapper
    .session-status
    p
    span.upcoming-session {
    background-color: #f5a623;
  }
  .SessionlistMultitracker
    .white-box-wrapper
    .session-status
    p
    span.active-session {
    background-color: #4bab5e;
  }
  .SessionlistMultitracker
    .white-box-wrapper
    .session-status
    p
    span.finish-session {
    background-color: #c2c5cc;
  }

  /* Title - 20px Inter medium black, 14px gap from status row (Figma) */
  .SessionlistMultitracker .white-box-wrapper .left-area-hld h2 {
    font-family: "Inter", sans-serif;
    font-size: 20px !important;
    font-weight: 500 !important;
    line-height: 24px !important; /* Figma is 16px but 24px keeps descenders */
    color: #000000 !important;
    margin-top: 14px !important;
    margin-bottom: 0 !important;
  }

  /* On Demand / action button - Figma: #4BAB5E, rounded-6, 10px 14-16, white 16/500 */
  .SessionlistMultitracker .white-box-wrapper a.icon-bookmark1,
  .SessionlistMultitracker .white-box-wrapper .bmark-pupupbtn.new-btn-design {
    background-color: #4bab5e !important;
    color: #ffffff !important;
    border-radius: 6px !important;
    /* padding: 10px 16px 10px 14px !important; */
    font-family: "Inter", sans-serif;
    font-size: 16px !important;
    font-weight: 500 !important;
    line-height: 16px !important;
    display: inline-flex !important;
    align-items: center;
    gap: 10px;
    box-shadow: none !important;
    border: 0 !important;
    text-decoration: none !important;
  }
  .SessionlistMultitracker .white-box-wrapper a.icon-bookmark1:hover,
  .SessionlistMultitracker
    .white-box-wrapper
    .bmark-pupupbtn.new-btn-design:hover {
    background-color: #3f9b51 !important;
  }
  /* Visually distinguish past sessions (Figma uses opacity 0.3/0.5) */
  .SessionlistMultitracker
    .white-box-wrapper:has(.finish-session)
    a.icon-bookmark1,
  .SessionlistMultitracker
    .white-box-wrapper:has(.finish-session)
    .bmark-pupupbtn {
    opacity: 0.5 !important;
  }

  .SessionlistMultitracker
    .white-box-wrapper:has(.finish-session)
    a.icon-bookmark1.ongoing-status {
    opacity: 1 !important;
  }
  /* =====================================================================
     Animated gradient border - Figma highlights only the FIRST upcoming
     card (the "next up" session). Implementation uses background-clip,
     which is the most reliable cross-browser way to paint a gradient
     border without a separate ::before / mask hack:

       border:     3px solid transparent      <- carves a 3px border slot
       background: white padding-box,         <- white inside the border
                   gradient border-box        <- gradient in the border

     Animating background-position on the second layer cycles the
     colors through the border. The first layer stays put.
  ===================================================================== */
  /* Apply the animated border to LIVE (active-session) cards.
     The selector is scoped to `.session-status .active-session` so it
     can only match the actual status indicator dot, never some other
     descendant that happens to share the class. The `.e2m-live-demo`
     selector is also kept so the same animated border can be applied
     to any preview / sample Live card without changing this rule.

     Border ring is painted with a *conic* gradient (the colors are
     distributed around a center point), which means rotating the
     gradient's start angle visually rotates the colors AROUND the
     card edge - top, right, bottom, left in sequence - instead of
     just flowing horizontally like a linear gradient would. */
  .SessionlistMultitracker
    .white-box-wrapper:has(.session-status .active-session),
  .SessionlistMultitracker .white-box-wrapper.e2m-live-demo {
    border: 3px solid transparent !important;
    background: linear-gradient(#ffffff, #ffffff) padding-box,
      conic-gradient(
          from var(--e2m-border-angle, 0deg),
          #213fd2,
          #0b84ee,
          #7cfff2,
          #f159ff,
          #213fd2
        )
        border-box !important;
    background-size: 100% 100%, 100% 100% !important;
    background-repeat: no-repeat, no-repeat !important;
    background-position: 0 0, 0 0 !important;
    box-shadow: none !important;
    animation: e2m-session-border-flow 3s linear infinite;
  }
  /* Fade the action button on EVERY upcoming-session card. Previously
     this used `tab-pane1 > div:not(:first-child)` which skipped the
     first row entirely - now the rule is keyed off the card's own
     status indicator, so every upcoming card gets opacity 0.5 and the
     highlighted Live card (or live demo) keeps its button at full
     opacity. */
  .SessionlistMultitracker
    .white-box-wrapper:has(.session-status .upcoming-session)
    a.icon-bookmark1,
  .SessionlistMultitracker
    .white-box-wrapper:has(.session-status .upcoming-session)
    .bmark-pupupbtn.new-btn-design {
    opacity: 0.5;
  }
  
  .SessionlistMultitracker
    .white-box-wrapper:has(.session-status .upcoming-session)
    a.icon-bookmark1.ongoing-status {
    opacity: 1 !important;
  }
}

/* Register `--e2m-border-angle` as an <angle> so the browser knows
   how to interpolate it. Without this @property declaration the var()
   would be treated as an opaque string and the animation would snap
   straight from start to end rather than smoothly rotating.
   Animating 0deg -> -360deg sweeps the conic gradient anti-clockwise
   once per cycle; switch to `360deg` for clockwise. */
@property --e2m-border-angle {
  syntax: "<angle>";
  initial-value: 0deg;
  inherits: false;
}
@keyframes e2m-session-border-flow {
  to {
    --e2m-border-angle: -360deg;
  }
}

/* Responsive: 768px and below - same flex row, scaled down padding/fonts */
@media only screen and (max-width: 767px) {
  .SessionlistMultitracker.session-list-wrapper > .container-fluid {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .SessionlistMultitracker.session-list-wrapper .white-box-wrapper {
    background: #ffffff !important;
    border: 0 !important;
    border-radius: 14px !important;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.12) !important;
    margin-left: 0 !important;
    margin-bottom: 14px !important;
    overflow: visible;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 16px;
    padding: 16px 16px !important;
  }
  .SessionlistMultitracker .white-box-wrapper .time-location {
    position: static !important;
    width: 64px !important;
    min-width: 64px !important;
    height: auto !important;
    left: auto !important;
    top: auto !important;
    bottom: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    background: transparent !important;
    border-radius: 0 !important;
    flex-shrink: 0;
  }
  .SessionlistMultitracker .white-box-wrapper .time-location ul {
    margin: 0 !important;
    padding: 0 !important;
    list-style: none;
  }
  .SessionlistMultitracker .white-box-wrapper .time-location ul li span {
    display: flex !important;
    flex-direction: column !important;
    gap: 4px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 16px !important;
    color: #000000 !important;
  }
  .SessionlistMultitracker .white-box-wrapper .main-divider-wrap {
    flex: 1 1 auto;
    min-width: 0;
  }
  .SessionlistMultitracker .white-box-wrapper .main-divider {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    margin: 0 !important;
    float: none !important;
  }
  .SessionlistMultitracker .white-box-wrapper .main-divider [class*="col-"] {
    padding: 0 !important;
    flex: 1 1 auto !important;
    max-width: none !important;
  }
  .SessionlistMultitracker .white-box-wrapper .left-area-hld,
  .SessionlistMultitracker .white-box-wrapper .right-area-hld {
    padding: 0 !important;
    height: auto !important;
    display: flex !important;
  }
  .SessionlistMultitracker .white-box-wrapper .left-area-hld {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px !important;
  }
  .SessionlistMultitracker .white-box-wrapper .right-area-hld {
    align-items: center !important;
    justify-content: flex-end !important;
    flex-shrink: 0;
  }
  .SessionlistMultitracker .white-box-wrapper .left-area-hld h2 {
    font-size: 16px !important;
    line-height: 20px !important;
    font-weight: 500 !important;
    margin: 0 !important;
  }
  .SessionlistMultitracker .white-box-wrapper a.icon-bookmark1,
  .SessionlistMultitracker .white-box-wrapper .bmark-pupupbtn.new-btn-design {
    background-color: #4bab5e !important;
    color: #ffffff !important;
    border-radius: 6px !important;
    padding: 9px 14px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    gap: 8px;
    display: inline-flex !important;
    align-items: center;
  }
  .nav.nav-tabs.session-nav-tab .nav-item .nav-link {
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(7px);
    color: #ffffff !important;
    border-radius: 46px;
    padding: 7px 16px;
    font-size: 14px;
    font-weight: 500;
  }
  .nav.nav-tabs.session-nav-tab .nav-item .nav-link.active {
    background-color: #ffffff !important;
    color: #000000 !important;
  }
}
</style>

<template>
  <div @click="onClickHandler">
    <div id="divContainer" class="page-effect" v-on:click="exitmenu">
      <section
        id="sectionId"
        class="session-list-wrapper d-flex body-content SessionlistMultitracker"
      >
        <div class="container-fluid mob-mx-20">
          <div
            class="blank-expo-section mt-16 mb-16"
            v-if="
              isAdminComponent &&
              dateTabs.length == 0 &&
              sessionSettingsLoaded &&
              sessionsLoaded &&
              mySessionsLoaded
            "
          >
            <img src="../assets/Images/self-service/session-add.png" />
            <!-- <h3 class="mt-3">Create Sessions</h3>
            <p class="my-3">
              Choose from 3 different session types that suits your requirement.
              When a session is live, attendees will be able to see the video
              streams of designated speakers. Learn more about session types
            </p> -->
            <!-- <v-btn dark color="#1a73e8" class="save-standard mt-3" data-toggle="dropdown"><v-icon size="20px" color="#ffffff">mdi-plus</v-icon> Add New Sessions</v-btn> -->
          </div>
          <div class="row session-head-wrap mb-0">
            <v-col md="6" cols="12" v-if="!isAdminComponent">
              <h1 id="headerText" class="page-head text-uppercase mt-3">
                {{ headerText }}
              </h1>
              <!-- <v-autocomplete
                v-if="$route.path.includes('mainlobby')"
                dense
                outlined
                v-model="speakerEvent"
                :items="$store.state.MappedEvent"
                prepend-inner-icon="search"
                return-object
                hide-details
                label="Select Event"
                item-text="EventFullName"
              ></v-autocomplete> -->
              <!-- <h1 v-else id="headerText" class="page-head text-uppercase"></h1> -->
            </v-col>
            <v-col
              md="6"
              cols="12"
              v-if="!isAdminComponent"
              class="d-flex justify-end align-center"
            >
              <h6 class="session-time-zone mt-md-1 mb-0" style="color: #fff">
                {{ localTimeZone }}
              </h6>
            </v-col>
            <v-col
              v-if="
                isAdminComponent &&
                sessionSettingsLoaded &&
                sessionsLoaded &&
                mySessionsLoaded
              "
              :md="isAdminComponent ? 12 : 6"
              cols="12"
            >
              <div
                :class="
                  isAdminComponent && dateTabs.length == 0
                    ? 'd-flex align-items-center justify-center'
                    : 'd-flex align-items-center justify-end'
                "
              >
                <div class="dropdown ss-create-new final-button">
                  <v-btn
                    color="#1a73e8"
                    large
                    dark
                    class="reg-button dropdown-toggle"
                    data-toggle="dropdown"
                    @click="OpenAddSessionPopup(3, 'Live Panel', 0)"
                  >
                    Create New
                  </v-btn>
                  <div class="dropdown-menu d-none">
                    <a
                      class="dropdown-item ss-lpico"
                      href="#"
                      @click="OpenAddSessionPopup(3, 'Live Panel', 0)"
                      >Live Panel (Webinar)</a
                    >
                    <!-- <a
                      class="dropdown-item ss-rtico"
                      href="#"
                      @click="OpenAddSessionPopup(4, 'Round Table', 0)"
                      >Round Table</a
                    > -->
                    <!-- <a
                      class="dropdown-item ss-ltico"
                      href="#"
                      @click="OpenAddSessionPopup(2. 'Live Stream', 0)"
                      >Live Stream
                    </a>
                    <a
                      class="dropdown-item ss-ondico"
                      href="#"
                      @click="OpenAddSessionPopup(1, 'On Demand', 0)"
                      >On Demand
                    </a> -->
                    <a
                      class="dropdown-item ss-inpico"
                      href="#"
                      @click="OpenAddSessionPopup(5, 'In-Person', 0)"
                      >In-Person
                    </a>
                  </div>
                </div>
              </div>
            </v-col>
            <div
              v-show="
                !isAdminComponent &&
                AgendaFilterOption == 2 &&
                selectedAgendaType >= 0 &&
                sessionSettingsLoaded &&
                mySessionsLoaded &&
                mySessions.length > 0
              "
              class="session-head-tab-wrapper d-none1"
            >
              <button
                :class="
                  selectedAgendaType == 1
                    ? 'common-tab-button border-left-radius active-btn'
                    : 'common-tab-button border-left-radius'
                "
                @click="onAgendaTypeChanged(1)"
              >
                {{ $t("sessions.myagenda") }}
              </button>
              <button
                :class="
                  selectedAgendaType == 0
                    ? 'common-tab-button border-right-radius active-btn'
                    : 'common-tab-button border-right-radius'
                "
                @click="onAgendaTypeChanged(0)"
              >
                {{ $t("sessions.fullagenda") }}
              </button>
            </div>
          </div>
          <div class="row session-tab-wrapper mt-0" style="getWidth()">
            <div class="" style="width: 100%">
              <div class="col-md-12 py-0">
                <!--<div class="mobile-session-dropdown d-none">
                  <select
                    v-model="selectedDateValue"
                    @change="mobileDropdownChange()"
                  >
                    <option
                      v-for="dateTab in dateTabs"
                      v-bind:key="dateTab.DateTabId"
                      :value="dateTab.DateTabId"
                    >
                      {{ dateTab.DateTabLabel }}
                    </option>
                  </select>
                </div>-->

                <ul
                  v-if="!isMobileView"
                  class="nav nav-tabs session-nav-tab"
                  role="tablist"
                >
                  <li
                    v-for="dateTab in dateTabs"
                    :key="dateTab.DateTabId"
                    class="nav-item"
                  >
                    <a
                      @click="
                        onTabChange(
                          dateTab.DateTabId,
                          dateTab.StartTime,
                          dateTab.EndTime
                        )
                      "
                      v-bind:class="
                        dateTab.DateTabId == selectedTabId
                          ? 'nav-link active'
                          : 'nav-link'
                      "
                      data-tag="sessionDate"
                    >
                      {{ dateTab.DateTabLabel }}
                      <!---{{ dateTab.StartTime }}:{{dateTab.EndTime}}-->
                    </a>
                  </li>
                </ul>
                <hooper
                  v-show="isMobileView"
                  ref="hooperSlide"
                  :settings="hooperSettings"
                  @afterSlide="afterSlideTab"
                  class="nav nav-tabs session-nav-tab session_tab"
                  style="height: 60px"
                >
                  <slide
                    v-for="(dateTab, indx) in dateTabs"
                    :key="indx"
                    :index="indx"
                  >
                    <div
                      @click="
                        onTabChange(
                          dateTab.DateTabId,
                          dateTab.StartTime,
                          dateTab.EndTime
                        )
                      "
                      class="nav-item item"
                    >
                      <a class="nav-link px-0 d-inline-block">{{
                        dateTab.DateTabLabel
                      }}</a>
                    </div>
                  </slide>
                  <!--<hooper-navigation slot="hooper-addons"></hooper-navigation>
                  <hooper-pagination
                    slot="hooper-addons"
                    mode="fraction"
                  ></hooper-pagination>-->
                </hooper>

                <!--<div class="slider-area position-relative">
                  <div class="sorting-carousel">
                    <carousel
                      :loop="false"
                      :autoplay="false"
                      :mouse-drag="true"
                      :margin="10"
                      :items="20"
                      :dots="false"
                      :nav="false"
                      responsive-class:true
                      :responsive="{
                        0: { items: 1 },
                        600: { items: 3 },
                        800: { items: 4 },
                        1000: { items: 6 },
                        1200: { items: 8 },
                        1400: { items: 10 },
                        1700: { items: 12 },
                        3000: { items: 15 },
                      }"
                    >
                      <div
                        v-for="(dateTab, indx) in dateTabs"
                        :id="'a2_' + dateTab.DateTabId"
                        :key="indx"
                        :index="indx"
                        @click="
                          onTabChange(
                            dateTab.DateTabId,
                            dateTab.StartTime,
                            dateTab.EndTime
                          )
                        "
                      >
                        <a class="nav-link px-0">{{ dateTab.DateTabLabel }}</a>
                      </div>
                    </carousel>
                  </div>
                </div>-->
              </div>
            </div>
            <br />
            <div
              v-show="
                sessionSettingsLoaded && sessionsLoaded && mySessionsLoaded
              "
              class="tab-content col-md-12"
              id="dvMainTabContent"
            >
              <div
                v-for="sessionContent in selectedTabSessions"
                v-bind:key="sessionContent.DateTabId"
                v-bind:class="'tab-pane1 ' + sessionContent.CurrentClass"
              >
                <div
                  v-for="sessionRow in sessionContent.SessionRowList"
                  :key="sessionRow.SessionCollection[0].SessionId"
                >
                  <div>
                    <div
                      v-bind:class="
                        'white-box-wrapper ' + sessionRow.SessionClass
                      "
                    >
                      <div
                        :class="
                          hiddenTrackClass(1, sessionRow.SessionCollection, 0)
                        "
                        :style="
                          sessionRow.SessionCollection[0].ShowFeatureImage
                            ? 'background:transparent'
                            : ''
                        "
                      >
                        <ul>
                          <li>
                            <span v-show="!sessionRow.HideTime">
                              {{ sessionRow.StartTimeLabel }}
                              <br />
                              {{
                                sessionRow.EndTimeLabel == "12:00 AM"
                                  ? "11:59 PM"
                                  : sessionRow.EndTimeLabel
                              }}
                            </span>
                          </li>
                          <li style="display: none">
                            <span></span>
                          </li>
                        </ul>
                      </div>
                      <div
                        v-for="(
                          singleSession, index
                        ) in sessionRow.SessionCollection"
                        :id="'session_wrap_' + singleSession.SessionId"
                        :key="singleSession.SessionId"
                        class="main-divider-wrap my-0 py-0"
                      >
                        <div
                          v-if="singleSession.ShowFeatureImage"
                          :class="rowClassCss(index)"
                          style="
                            min-height: 70px;
                            background-repeat: no-repeat;
                            background-size: cover;
                            background-position: center center;
                          "
                          :style="
                            singleSession.ShowFeatureImage
                              ? 'background-image:url(' +
                                singleSession.SessionTypeDetails.FeatureImage +
                                ')'
                              : ''
                          "
                        ></div>
                        <div
                          v-else
                          :class="
                            index < 3
                              ? rowClassCss(index)
                              : 'main-divider-continue mr-2 main-divider  py-0'
                          "
                        >
                          <div
                            :class="
                              sessionRow.SessionClass.includes('three-session')
                                ? 'col-lg-12 col-md-12 col-12 py-0'
                                : sessionRow.SessionClass.includes(
                                    'two-session'
                                  )
                                ? ipadScreen == false
                                  ? 'col-lg-8 col-md-8 py-0 col-12'
                                  : 'col-lg-12 col-md-8 py-0 col-12'
                                : 'col-lg-8 col-md-6 py-0'
                            "
                          >
                            <div class="col-12 pl-0">
                              <div
                                :style="
                                  singleSession.HideStatus
                                    ? 'visibility:hidden'
                                    : ''
                                "
                                class="session-status"
                              >
                                <p>
                                  <span
                                    v-bind:class="singleSession.StatusClass"
                                  ></span>
                                  {{ singleSession.StatusDisplayText }}
                                </p>
                              </div>
                            </div>
                            <div
                              data-tag="singleSessionDetails"
                              class="left-area-hld"
                              @click="DisplaySessionDetails(singleSession)"
                            >
                              <h2
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:data-original-title="singleSession.Name"
                                :style="
                                  singleSession.HideTitle
                                    ? 'visibility:hidden'
                                    : ''
                                "
                              >
                                {{ singleSession.Name }}
                              </h2>
                              <p v-if="sessionRow.RowSessionCount == 1">
                                {{
                                  sessionRow.SessionCollection[0]
                                    .DescriptionShort
                                }}
                              </p>
                            </div>
                            <div
                              v-if="
                                isMobileView && singleSession.Track.TrackName
                              "
                              class="track-box track-box-continue"
                              data-toggle="tooltip"
                              data-placement="top"
                              :data-original-title="
                                singleSession.Track.TrackName
                              "
                              :style="
                                'background-color:' +
                                trackColor(singleSession.Track.TrackID)
                              "
                            >
                              {{ singleSession.Track.TrackName }}
                            </div>
                            <p v-if="isMobileView" class="time-location-mobile">
                              {{ sessionRow.StartTimeLabel }}
                              -
                              {{ sessionRow.EndTimeLabel }}
                            </p>
                          </div>
                          <div
                            :class="
                              sessionRow.SessionClass.includes('three-session')
                                ? 'col-lg-8 col-md-12 col-12 py-0'
                                : sessionRow.SessionClass.includes(
                                    'two-session'
                                  )
                                ? ipadScreen == false
                                  ? 'col-lg-4 col-md-4 col-12'
                                  : 'col-lg-8 col-md-12 col-12'
                                : 'col-lg-4 col-md-6 pl-0'
                            "
                          >
                            <div class="right-area-hld">
                              <div
                                v-if="!isMobileView"
                                :class="
                                  hiddenTrackClass(
                                    2,
                                    sessionRow.SessionCollection,
                                    index
                                  )
                                "
                                data-toggle="tooltip"
                                data-placement="top"
                                :data-original-title="
                                  singleSession.Track.TrackName
                                "
                                :style="
                                  'background-color:' +
                                  trackColor(singleSession.Track.TrackID)
                                "
                              >
                                {{ singleSession.Track.TrackName }}
                              </div>
                              <div id="dvBroadcast">
                                <div
                                  v-if="sessionRow.RowSessionCount == 1"
                                  class="d-flex align-items-center"
                                  :style="
                                    singleSession.HideSpeakers
                                      ? 'visibility:hidden;'
                                      : ''
                                  "
                                >
                                  <a
                                    v-for="(
                                      speaker, index
                                    ) in visibleSessionSpeakers(
                                      singleSession.MappedSpeakers
                                    )"
                                    v-bind:key="speaker.AttendeeId"
                                    class="schedule-speaker w-inline-block"
                                    data-tag="sessionSpeakerDetails"
                                    v-show="
                                      index < 5 ||
                                      (index == 5 &&
                                        singleSession.MappedSpeakers.length ==
                                          6)
                                    "
                                    @click="
                                      openSpeakerDetails(speaker.AttendeeId)
                                    "
                                  >
                                    <img
                                      v-if="speaker.ProfilePictureURL != ''"
                                      v-bind:src="
                                        getCDNUrl(speaker.ProfilePictureURL)
                                      "
                                      v-bind:alt="speaker.NameInitial"
                                      class="schedule-speaker-image"
                                      data-toggle="tooltip"
                                      data-html="true"
                                      v-bind:title="
                                        '<strong>' +
                                        speaker.Name +
                                        '</strong><br />' +
                                        speaker.Company
                                      "
                                      v-bind:data-original-title="
                                        speaker.Name + ', ' + speaker.Company
                                      "
                                    />
                                    <span
                                      v-else-if="speaker.NameInitial != ''"
                                      class="speaker-name-initial"
                                      data-toggle="tooltip"
                                      data-html="true"
                                      v-bind:title="
                                        '<strong>' +
                                        speaker.Name +
                                        '</strong><br />' +
                                        speaker.Company
                                      "
                                      v-bind:data-original-title="
                                        speaker.Name + ', ' + speaker.Company
                                      "
                                      >{{ speaker.NameInitial }}</span
                                    >
                                    <img
                                      v-else
                                      v-bind:src="avatarImageUrl"
                                      v-bind:alt="speaker.NameInitial"
                                      class="schedule-speaker-image"
                                      data-toggle="tooltip"
                                      data-html="true"
                                      v-bind:title="
                                        '<strong>' +
                                        speaker.Name +
                                        '</strong><br />' +
                                        speaker.Company
                                      "
                                      v-bind:data-original-title="
                                        speaker.Name + ', ' + speaker.Company
                                      "
                                    />
                                  </a>
                                  <span
                                    v-if="
                                      singleSession.MappedSpeakers.length > 6
                                    "
                                    class="plus-circle cursor-pointer"
                                    @click="
                                      DisplaySessionDetails(singleSession)
                                    "
                                    >+{{
                                      sessionRow.SessionCollection[0].Plushcount
                                    }}</span
                                  >
                                </div>
                                <a
                                  href="javascript:void(0)"
                                  class="icon-bookmark1 bmark-pupupbtn new-btn-design"
                                  :class="singleSession.LinkClass"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  :data-original-title="
                                    !singleSession.IsSpeaker &&
                                    !singleSession.IsHost &&
                                    singleSession.IsRTMP &&
                                    !singleSession.RTMPStarted &&
                                    singleSession.StatusClass ==
                                      'active-session'
                                      ? 'Waiting for the host to start this webiner'
                                      : singleSession.SessionTypeDetails
                                          .TypeName
                                  "
                                  :data-tag="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  @click="
                                    singleSession.IsLive
                                      ? onStartSession(singleSession.SessionId)
                                      : null
                                  "
                                  :style="
                                    singleSession.HideJoinButton
                                      ? 'visibility:hidden;'
                                      : ''
                                  "
                                >
                                  <img
                                    v-if="
                                      singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.OnDemandTypeID
                                    "
                                    data-tag="On-Demand"
                                    src="../assets/Images/on-demand-white.svg"
                                  />
                                  <img
                                    v-else-if="
                                      singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.LiveStreamTypeID
                                    "
                                    src="../assets/Images/live-stream-white.svg"
                                  />
                                  <img
                                    v-else-if="
                                      singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.LivePanelTypeID
                                    "
                                    src="../assets/Images/live-panel-white.svg"
                                  />
                                  <img
                                    v-else-if="
                                      singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.RoundTableTypeID
                                    "
                                    src="../assets/Images/round-table-white.svg"
                                  />
                                  <span
                                    v-else-if="
                                      singleSession.SessionTypeDetails.TypeID ==
                                        GlobalKeysData.CustomUrlTypeID ||
                                      singleSession.SessionTypeDetails.TypeID ==
                                        GlobalKeysData.InPersonTypeID
                                    "
                                    class="session-type-icon"
                                  >
                                    <img :src="singleSession.InPersonIcon" />
                                  </span>
                                  <span
                                    v-if="
                                      singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.OnDemandTypeID
                                    "
                                  >
                                    {{
                                      singleSession.IsLive
                                        ? "WATCH NOW"
                                        : singleSession.SessionTypeDetails
                                            .TypeName
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.LiveStreamTypeID
                                    "
                                  >
                                    {{
                                      singleSession.SessionTypeDetails.TypeName
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.LivePanelTypeID
                                    "
                                  >
                                    {{
                                      singleSession.HasBackStageAccess &&
                                      singleSession.IsLive
                                        ? "ENTER BACKSTAGE"
                                        : "JOIN NOW"
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.RoundTableTypeID
                                    "
                                  >
                                    JOIN NOW
                                  </span>
                                  <span
                                    v-if="
                                      singleSession.SessionTypeDetails.TypeID ==
                                        GlobalKeysData.CustomUrlTypeID ||
                                      singleSession.SessionTypeDetails.TypeID ==
                                        GlobalKeysData.InPersonTypeID
                                    "
                                  >
                                    {{ singleSession.InPersonLabel }}
                                  </span>
                                </a>
                                <a
                                  v-if="
                                    false &&
                                    singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.OnDemandTypeID &&
                                    singleSession.IsLive
                                  "
                                  href="javascript:void(0)"
                                  v-on:click="
                                    ShowBroadCastPg(
                                      singleSession.SessionId,
                                      GlobalKeysData.IsVideoInNewTab,
                                      'video',
                                      eventId,
                                      GlobalKeysData.IsOpenInternalPlayer
                                    )
                                  "
                                  v-bind:class="
                                    'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                    singleSession.LinkClass
                                  "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  v-bind:title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  v-bind:data-original-title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  data-tag="On-Demand"
                                >
                                  <img
                                    data-tag="On-Demand"
                                    src="../assets/Images/on-demand-white.svg"
                                  />
                                  <span data-tag="On-Demand">WATCH NOW</span>
                                </a>
                                <a
                                  v-else-if="
                                    false &&
                                    singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.OnDemandTypeID &&
                                    !singleSession.IsLive
                                  "
                                  href="javascript:void(0)"
                                  v-bind:class="
                                    'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                    singleSession.LinkClass
                                  "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  v-bind:title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  v-bind:data-original-title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                >
                                  <img
                                    src="../assets/Images/on-demand-white.svg"
                                  />
                                  <span>{{
                                    singleSession.SessionTypeDetails.TypeName
                                  }}</span>
                                </a>
                                <a
                                  v-else-if="
                                    false &&
                                    singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.LiveStreamTypeID &&
                                    singleSession.IsLive
                                  "
                                  v-bind:class="
                                    'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                    singleSession.LinkClass
                                  "
                                  v-on:click="
                                    ShowBroadCastPg(
                                      singleSession.SessionId,
                                      GlobalKeysData.IsVideoInNewTab,
                                      'video',
                                      eventId,
                                      GlobalKeysData.IsOpenInternalPlayer
                                    )
                                  "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-tag="live"
                                >
                                  <img
                                    src="../assets/Images/live-stream-white.svg"
                                  />
                                  <span>{{
                                    singleSession.SessionTypeDetails.TypeName
                                  }}</span>
                                </a>
                                <a
                                  v-else-if="
                                    false &&
                                    singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.LiveStreamTypeID &&
                                    !singleSession.IsLive
                                  "
                                  v-bind:class="
                                    'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                    singleSession.LinkClass
                                  "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-tag="live"
                                >
                                  <img
                                    src="../assets/Images/live-stream-white.svg"
                                  />
                                  <span>{{
                                    singleSession.SessionTypeDetails.TypeName
                                  }}</span>
                                </a>
                                <a
                                  v-else-if="
                                    false &&
                                    singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.RoundTableTypeID &&
                                    singleSession.IsLive
                                  "
                                  href="javascript:void(0)"
                                  v-on:click="
                                    goToRTPage(singleSession.SessionId)
                                  "
                                  v-bind:class="
                                    'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                    singleSession.LinkClass
                                  "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  v-bind:title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  v-bind:data-original-title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  data-tag="roundTable"
                                >
                                  <img
                                    src="../assets/Images/round-table-white.svg"
                                  />
                                  <span>JOIN NOW</span>
                                </a>
                                <a
                                  v-else-if="
                                    false &&
                                    singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.RoundTableTypeID &&
                                    !singleSession.IsLive
                                  "
                                  href="javascript:void(0)"
                                  v-bind:class="
                                    'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                    singleSession.LinkClass
                                  "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  v-bind:title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  v-bind:data-original-title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  data-tag="roundTable"
                                >
                                  <img
                                    src="../assets/Images/round-table-white.svg"
                                  />
                                  <span>JOIN NOW</span>
                                </a>
                                <a
                                  v-else-if="
                                    false &&
                                    singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.LivePanelTypeID &&
                                    singleSession.IsLive
                                  "
                                  href="javascript:void(0)"
                                  v-on:click="
                                    JoinLivePanel(
                                      GlobalKeysData.videoParamsEncryptURL,
                                      GlobalKeysData.BroadcastStartURL,
                                      GlobalKeysData.BroadcastViewURL,
                                      GlobalKeysData.IsBroadcastInNewTab,
                                      singleSession.SessionId,
                                      GlobalKeysData.ChannelPrefix,
                                      GlobalKeysData.BroadcastID,
                                      GlobalKeysData.BroadcastCertificate,
                                      GlobalKeysData.BroadcastSpeakerApiUrl,
                                      GlobalKeysData.BroadcastAttendeeApiUrl,
                                      GlobalKeysData.BroadcastvalidityHours,
                                      userid,
                                      eventId,
                                      'startbroadcast',
                                      singleSession.Name,
                                      singleSession.broadcastUrlForSession,
                                      clientID,
                                      singleSession.IamInThesession,
                                      GlobalKeysData.IsOpenInternalPlayer,
                                      singleSession.StreamingClient,
                                      singleSession.MappedHosts,
                                      singleSession.MappedSpeakers,
                                      singleSession.Zoom_Detail,
                                      singleSession.IsZoomRTMP,
                                      singleSession.ZoomRTMPMUX_detail
                                    )
                                  "
                                  v-bind:class="
                                    'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                    singleSession.LinkClass
                                  "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  v-bind:title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  v-bind:data-original-title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  data-tag="forGreenRoom"
                                >
                                  <img
                                    src="../assets/Images/live-panel-white.svg"
                                  />
                                  <span>{{
                                    singleSession.HasBackStageAccess
                                      ? "ENTER BACKSTAGE"
                                      : "JOIN NOW"
                                  }}</span>
                                </a>
                                <a
                                  v-else-if="
                                    false &&
                                    singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.LivePanelTypeID &&
                                    !singleSession.IsLive
                                  "
                                  href="javascript:void(0)"
                                  v-bind:class="
                                    'icon-bookmark1 bmark-pupupbtn new-btn-design ' +
                                    singleSession.LinkClass
                                  "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  v-bind:title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  v-bind:data-original-title="
                                    singleSession.SessionTypeDetails.TypeName
                                  "
                                  data-tag="joinSession"
                                >
                                  <img
                                    src="../assets/Images/live-panel-white.svg"
                                  />
                                  <span>JOIN NOW</span>
                                </a>
                                <a
                                  v-else-if="
                                    false &&
                                    singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.InPersonTypeID &&
                                    singleSession.IsLive
                                  "
                                  href="javascript:void(0)"
                                  v-on:click="
                                    JoinLivePanel(
                                      GlobalKeysData.videoParamsEncryptURL,
                                      GlobalKeysData.BroadcastStartURL,
                                      GlobalKeysData.BroadcastViewURL,
                                      GlobalKeysData.IsBroadcastInNewTab,
                                      singleSession.SessionId,
                                      GlobalKeysData.ChannelPrefix,
                                      GlobalKeysData.BroadcastID,
                                      GlobalKeysData.BroadcastCertificate,
                                      GlobalKeysData.BroadcastSpeakerApiUrl,
                                      GlobalKeysData.BroadcastAttendeeApiUrl,
                                      GlobalKeysData.BroadcastvalidityHours,
                                      userid,
                                      eventId,
                                      'startbroadcast',
                                      singleSession.Name,
                                      singleSession.broadcastUrlForSession,
                                      clientID,
                                      singleSession.IamInThesession,
                                      GlobalKeysData.IsOpenInternalPlayer,
                                      singleSession.StreamingClient,
                                      singleSession.MappedHosts,
                                      singleSession.MappedSpeakers,
                                      singleSession.Zoom_Detail,
                                      singleSession.IsZoomRTMP,
                                      singleSession.ZoomRTMPMUX_detail,
                                      singleSession.InPersonURL
                                    )
                                  "
                                  v-bind:class="
                                    'icon-bookmark1 bmark-pupupbtn new-btn-design session-link ' +
                                    singleSession.LinkClass
                                  "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  v-bind:title="singleSession.InPersonLabel"
                                  v-bind:data-original-title="
                                    singleSession.InPersonLabel
                                  "
                                  data-tag="forGreenRoom"
                                >
                                  <span class="session-type-icon"
                                    ><img
                                      v-bind:src="singleSession.InPersonIcon"
                                  /></span>
                                  <span>{{ singleSession.InPersonLabel }}</span>
                                </a>
                                <a
                                  v-else-if="
                                    false &&
                                    singleSession.SessionTypeDetails.TypeID ==
                                      GlobalKeysData.InPersonTypeID &&
                                    !singleSession.IsLive
                                  "
                                  href="javascript:void(0)"
                                  v-bind:class="
                                    'icon-bookmark1 bmark-pupupbtn new-btn-design session-link ' +
                                    singleSession.LinkClass
                                  "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  v-bind:title="singleSession.InPersonLabel"
                                  v-bind:data-original-title="
                                    singleSession.InPersonLabel
                                  "
                                  data-tag="joinSession"
                                >
                                  <!--<img src="../assets/Images/live-panel.svg" />-->
                                  <span class="session-type-icon"
                                    ><img
                                      v-bind:src="singleSession.InPersonIcon"
                                  /></span>
                                  <span>{{ singleSession.InPersonLabel }}</span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="isAdminComponent"
                            class="edit-delete-session"
                          >
                            <v-switch
                              v-model="singleSession.IsPublished"
                              :loading="singleSession.IsStatusChanging"
                              @change="
                                sessionRow.SessionCollection[
                                  index
                                ].IsStatusChanging = true;
                                $parent.changeSessionStatus(
                                  singleSession.SessionId,
                                  singleSession.IsPublished
                                );
                              "
                            ></v-switch>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  icon
                                  @click="
                                    OpenAddSessionPopup(
                                      singleSession.SessionTypeDetails.TypeID,
                                      singleSession.SessionTypeDetails.TypeName,
                                      singleSession.SessionId
                                    )
                                  "
                                >
                                  <img
                                    src="../assets/Images/self-service/edit-self.svg"
                                  />
                                </v-btn>
                              </template>
                              <span class="v-tooltip-content v-tooltip-bottom"
                                >Edit Session</span
                              >
                            </v-tooltip>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  icon
                                  :loading="singleSession.IsDeleting"
                                  @click="
                                    requestConfirmDeleteSession(
                                      singleSession.SessionId
                                    )
                                  "
                                >
                                  <img
                                    src="../assets/Images/self-service/delete-self.svg"
                                  />
                                </v-btn>
                              </template>
                              <span class="v-tooltip-content v-tooltip-bottom"
                                >Delete Session</span
                              >
                            </v-tooltip>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="
                          sessionRow.SessionCollection.length > 3 &&
                          sessionRow.SessionCollection.length % 3 == 2
                        "
                        style="margin-top: 60px; position: relative !important"
                        class="main-divider-wrap my-0 py-0 visibility-hidden"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <v-dialog
      v-model="rtmpDialog.state"
      persistent
      transition="dialog-bottom-transition"
      width="800"
    >
      <rtmpComponent
        :key="rtmpDialog.key"
        ref="rtmpComponent"
        v-bind:rtmpOptions="rtmpDialog.rtmpOptions"
        @rtmpActions="rtmpActions"
      />
    </v-dialog>
    <div
      class="modal fade modal-container"
      id="modalOpenBroadcast"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <button
            type="button"
            class="Maximize-icon"
            title="Maximize"
            v-on:click="MaximizeModal()"
          >
            <svg
              height="22px"
              viewBox="0 0 512.00533 512"
              width="22px"
              fill="#ffffff"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m10.671875 170.667969c-5.886719 0-10.66796875-4.777344-10.66796875-10.664063v-149.335937c0-5.886719 4.78124975-10.66406275 10.66796875-10.66406275h149.332031c5.890625 0 10.667969 4.77734375 10.667969 10.66406275 0 5.890625-4.777344 10.667969-10.667969 10.667969h-138.664062v138.667968c0 5.886719-4.78125 10.664063-10.667969 10.664063zm0 0"
              />
              <path
                d="m501.339844 170.667969c-5.890625 0-10.667969-4.777344-10.667969-10.664063v-138.667968h-138.667969c-5.886718 0-10.664062-4.777344-10.664062-10.667969 0-5.886719 4.777344-10.66406275 10.664062-10.66406275h149.335938c5.886718 0 10.664062 4.77734375 10.664062 10.66406275v149.335937c0 5.886719-4.777344 10.664063-10.664062 10.664063zm0 0"
              />
              <path
                d="m160.003906 512.003906h-149.332031c-5.886719 0-10.66796875-4.78125-10.66796875-10.667968v-149.332032c0-5.890625 4.78124975-10.667968 10.66796875-10.667968s10.667969 4.777343 10.667969 10.667968v138.664063h138.664062c5.890625 0 10.667969 4.78125 10.667969 10.667969 0 5.886718-4.777344 10.667968-10.667969 10.667968zm0 0"
              />
              <path
                d="m501.339844 512.003906h-149.335938c-5.886718 0-10.664062-4.78125-10.664062-10.667968 0-5.886719 4.777344-10.667969 10.664062-10.667969h138.667969v-138.664063c0-5.890625 4.777344-10.667968 10.667969-10.667968 5.886718 0 10.664062 4.777343 10.664062 10.667968v149.332032c0 5.886718-4.777344 10.667968-10.664062 10.667968zm0 0"
              />
              <path
                d="m181.339844 192.003906c-2.730469 0-5.460938-1.046875-7.554688-3.117187l-170.664062-170.664063c-4.160156-4.160156-4.160156-10.925781 0-15.085937 4.160156-4.15625 10.921875-4.15625 15.082031 0l170.667969 170.667969c4.160156 4.160156 4.160156 10.921874 0 15.082031-2.070313 2.070312-4.800782 3.117187-7.53125 3.117187zm0 0"
              />
              <path
                d="m330.671875 192.003906c-2.730469 0-5.460937-1.046875-7.550781-3.117187-4.160156-4.160157-4.160156-10.921875 0-15.082031l170.664062-170.667969c4.160156-4.15625 10.925782-4.15625 15.085938 0 4.160156 4.160156 4.160156 10.925781 0 15.085937l-170.667969 170.664063c-2.070313 2.070312-4.800781 3.117187-7.53125 3.117187zm0 0"
              />
              <path
                d="m501.339844 512.003906c-2.730469 0-5.460938-1.046875-7.554688-3.117187l-170.664062-170.664063c-4.160156-4.160156-4.160156-10.925781 0-15.085937 4.160156-4.15625 10.921875-4.15625 15.082031 0l170.667969 170.667969c4.160156 4.160156 4.160156 10.921874 0 15.082031-2.070313 2.070312-4.800782 3.117187-7.53125 3.117187zm0 0"
              />
              <path
                d="m10.671875 512.003906c-2.730469 0-5.460937-1.046875-7.550781-3.117187-4.160156-4.160157-4.160156-10.921875 0-15.082031l170.664062-170.667969c4.160156-4.15625 10.925782-4.15625 15.085938 0 4.160156 4.160156 4.160156 10.925781 0 15.085937l-170.667969 170.664063c-2.070313 2.070312-4.800781 3.117187-7.53125 3.117187zm0 0"
              />
            </svg>
          </button>
          <button
            type="button"
            class="minus"
            title="Minimize"
            v-on:click="minimizeModal()"
          >
            <svg
              version="1.1"
              id="Capa_1"
              fill="#ffffff"
              width="25px"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <g>
                  <rect y="236" width="512" height="40" />
                </g>
              </g>
            </svg>
          </button>
          <button
            v-on:click="CloseModal()"
            type="button"
            class="close"
            title="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.03"
              height="18.031"
              viewBox="0 0 18.03 18.031"
            >
              <path
                id="close.svg"
                fill="#ffffff"
                d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                transform="translate(-1412 -516)"
              />
            </svg>
          </button>
          <div class="modal-body">
            <iframe
              id="iframeBroadcast"
              src
              height="100%"
              width="100%"
              controls
              autoplay
              allow="camera;microphone"
            ></iframe>
          </div>
        </div>
      </div>

      <b-modal ref="my-modal" hide-footer title="Using Component Methods">
        <div class="d-block text-center"></div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideModal"
          style="opacity: 0"
          >{{ $t("sessions.closeme") }}</b-button
        >
        <b-button
          class="mt-2"
          variant="outline-warning"
          block
          @click="toggleModal"
          style="opacity: 0"
          >{{ $t("sessions.toggleme") }}</b-button
        >
      </b-modal>
    </div>
    <div
      class="modal right fade speakers-popup"
      id="myModal2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div
            class="modal-body new-addendee-list new-addendee-details px-0 pb-2"
          >
            <button
              type="button"
              id="btnModalClose"
              v-on:click="closeModal()"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <!------image hld start---->
            <div class="attendee-box-hld text-center pt-0">
              <div id="dvImgeHld" class="attendee-img-hld mx-auto">
                <img id="imgModalSpeakers" class="imguserthumb" />
              </div>
              <div id="dvImgeHldText" class="attendee-img-hld mx-auto"></div>
              <span id="spnSpkEmail" style="display: none"></span>
              <span id="spnSpkPhone" style="display: none"></span>
              <div class="attendee-des-hld">
                <h3 id="modalName"></h3>
                <p id="modalCompany"></p>
                <p id="modalTtile"></p>
              </div>
              <!--------social----->
              <div class="social-icon d-flex justify-content-center">
                <a id="anchFacebook" href="#" target="_blank">
                  <span id="spnFacebook">
                    <i class="fa fa-facebook" aria-hidden="true"></i>
                  </span>
                </a>
                <a id="anchTwitter" href="#" target="_blank">
                  <span id="spnTwitter">
                    <i class="fa fa-twitter" aria-hidden="true"></i>
                  </span>
                </a>
                <a id="anchLinkedIn" href="#" target="_blank">
                  <span id="spnLinkedIn">
                    <i class="fa fa-linkedin" aria-hidden="true"></i>
                  </span>
                </a>
              </div>
              <!--------social----->
              <!--button area start--->
              <div class="button-area-hld text-center btn-theme">
                <!-- <button class="btn request-meeting mt-1 border-tranprent">Request Meeting</button> -->
                <button
                  @click="OpenRequestMeeting"
                  data-target="#calendarModal"
                  data-toggle="modal"
                  v-show="ShowMeetingButton"
                  class="btn request-meeting mt-1 border-stranprent border-tranprent"
                >
                  {{ $t("sessions.requestmeeting") }}
                </button>
                <button
                  v-show="ShowSendMessageButton"
                  class="btn send-message ml-2 mt-1 request-meeting"
                >
                  {{ $t("sessions.sendmessage") }}
                </button>
              </div>
              <!---button area end-->
              <!-----tab-area------->
              <div class="speakers-detailstab session-list-wrapper">
                <ul
                  role="tablist"
                  id="ulTabList"
                  class="nav nav-tabs session-nav-tab text-uppercase"
                >
                  <li class="nav-item">
                    <a
                      data-toggle="tab"
                      href="#Biograply"
                      data-tag
                      class="nav-link active"
                      >{{ $t("sessions.biography") }}</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      data-toggle="tab"
                      href="#Session"
                      data-tag
                      class="nav-link"
                      >{{ $t("sessions.sessions") }}</a
                    >
                  </li>
                  <li class="nav-item" id="liResourceTab">
                    <a
                      data-toggle="tab"
                      href="#SpkModalResource"
                      data-tag
                      class="nav-link"
                      >{{ $t("sessions.resources") }}</a
                    >
                  </li>
                </ul>
              </div>
              <!-----tab conten  startt----->
              <div class="tab-content mt-3">
                <!--Biograply tab content start--->
                <div id="Biograply" class="tab-pane active">
                  <div id="modalProfile" class="text-left"></div>
                </div>
                <!------session tab start-->

                <div id="Session" class="tab-pane text-left">
                  <!-- <div class="session-tab-innerBox p-3 mb-2">
                    <h5 class>Testing Singapore Event</h5>
                    <p class="event-date">Jul 16 11:30 to Aug 31 15:30 Asia/Calcutta</p>
                  </div>
                  <div class="session-tab-innerBox p-3 mb-2">
                    <h5 class>Testing Singapore Event</h5>
                    <p class="event-date">Jul 16 11:30 to Aug 31 15:30 Asia/Calcutta</p>
                  </div>-->
                </div>
                <!------>
                <!------Resource tab start-->

                <div id="SpkModalResource" class="tab-pane text-left"></div>
              </div>
              <!----tab content wrapper end--->
            </div>
            <!------image hld end---->
          </div>
        </div>
        <!-- modal-content -->
      </div>
      <!-- modal-dialog -->
    </div>
    <RequestMeeting></RequestMeeting>
    <div
      id="RetryJoinInZoom"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 400px">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <div class="retry-modal p-4">
              <p style="font-size: 20px; font-weight: 600; color: #1e1f26">
                Please try again.
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="cancelRetryJoinInZoom"
                  >Cancel</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="retryJoinInZoom"
                  >Retry</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="showDeleteConfirmDialog" max-width="500px" hide-overlay>
      <v-card>
        <v-card-title>
          <div
            class="restore-default-head d-flex justify-content-end align-items-start"
          >
            <v-btn
              text
              fab
              color="#1c1d26"
              height="30px"
              width="30px"
              @click="showDeleteConfirmDialog = false"
              ><v-icon color="#1c1d26" size="25px">mdi-close</v-icon></v-btn
            >
          </div>
          <div
            class="confirmation-option-button pb-10 final-button d-flex justify-content-center align-items-center flex-column"
          >
            <h5>Are you sure you want to delete this session?</h5>
            <div class="mt-5">
              <v-btn
                dark
                large
                color="#1c1d26"
                width="120px"
                class="mr-2"
                @click="onConfirmDeleteSession"
                >Yes</v-btn
              >
              <v-btn
                large
                color="#1c1d26"
                outlined
                width="120px"
                @click="showDeleteConfirmDialog = false"
                >No</v-btn
              >
            </div>
          </div>
        </v-card-title>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="sessionDetailsPopup"
      width="1000px"
      content-class="reg-options-whole position-relative"
      style="z-index: 1047"
    >
      <v-card>
        <v-btn
          class="goto-option-close"
          icon
          @click="sessionDetailsPopup = false"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        >
        <v-card-text class="p-0">
          <SessionDetails
            :key="sessionDetailsKey"
            :sn="currentSession"
            :hide_speaker_enabled="hide_speaker_enabled"
            :isPublicPage="isPublicPage"
            :IsMyAgenda="IsMyAgenda"
            :AllowAddRemoveMyAgenda="AllowAddRemoveMyAgenda"
            @onStartSession="onStartSession"
            @addToMyAgenda="addToMyAgenda"
            @removeFromMyAgenda="removeFromMyAgenda"
            @openSpeakerDetails="openSpeakerDetails"
          ></SessionDetails>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="videoPlayerDialog"
      id="videoPlayerDialog"
      content-class="player-dialog"
      transition="scroll-x-reverse-transition"
      persistent
      scrollable
      style="z-index: 1150"
    >
      <v-card-text
        class="player-dialog-body px-0"
        style="font-size: 1rem; padding: 0; position: relative"
      >
        <!-- <v-btn icon @click="closeVideoPlayer"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        > -->
        <!-- <div style="">
          <div
            style="
              height: 40px;
              font-size: 18px;
              padding: 10px;
              background: #fff;
            "
          >
            {{ sessionTitle }}
          </div>
          <div>
          </div>
        </div> -->
        <button
          type="button"
          id="btnModalClose"
          v-on:click="closeVideoPlayer"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          style="position: absolute; top: 10px; right: 10px; color: #fff"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.03"
            height="18.031"
            viewBox="0 0 18.03 18.031"
          >
            <path
              id="close.svg"
              fill="#ffffff"
              d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
              transform="translate(-1412 -516)"
            />
          </svg>
        </button>
        <!-- <LiveStageNG
          v-if="playerDialog"
          :key="playerKey"
          :roomId="roomId"
          :dialogSessionId="dialogSessionId"
          :dialogEventId="dialogEventId"
          :dialogEventName="dialogEventName"
          :dialogEventCollectionName="dialogEventCollectionName"
          :dialTime="dialTime"
          :pipMode="playerPIPMode"
          :memberList="roomMemberList"
          @onCallStarted="onCallStarted"
          style=""
        ></LiveStageNG> -->
        <!-- style="display: none" -->

        <div class="body-content player-wrapper-hld">
          <div class="video-wrapper">
            <VideoPlayer
              id="videoPlayerApp"
              ref="videoPlayer"
              class="vjs-custom-skin"
              style="width: auto !important"
              :disablePictureInPicture="true"
              :options="videoPlayerOptions"
              @ended="onVideoPlayerEnded"
              @timeupdate="onVideoPlayerTimeUpdate"
            ></VideoPlayer>
          </div>
        </div>
      </v-card-text>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
import APIs from "../components/APIInit";
import rtmpComponent from "@/components/RTMPComponentNG.vue";
import RequestMeeting from "@/components/RequestMeeting.vue";
import SessionDetails from "@/components/SessionDetails.vue";
import VideoPlayer from "@/components/VideoPlayer.vue";
import router from "../router";
import analytics from "@/components/Analytics";
import axios from "axios";
import common from "@/common";
import { bus } from "@/main";
import {
  Hooper,
  Slide,
  //Pagination as HooperPagination,
  //Navigation as HooperNavigation,
} from "hooper";
//import "hooper/dist/hooper.css";
//import carousel from "vue-owl-carousel2";

var monthNamesShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
var sessionStatusRefreshTimer;
var zoomRTMPRefreshTimer;
var ZoomRTMPParticipantsListener;
var self;

export default {
  components: {
    RequestMeeting,
    rtmpComponent,
    Hooper,
    Slide,
    //HooperPagination,
    //HooperNavigation,
    //carousel,
    SessionDetails,
    VideoPlayer,
  },
  props: {
    isAdminComponent: {
      type: Boolean,
      default: false,
    },
    eventCollectionName: {
      type: String,
      default: "",
    },
    eventFullName: {
      type: String,
      default: "",
    },
    eventTimeZone: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      PlayOnDemandVideoOnPopup: false,
      videoPlayerDialog: false,
      // videoPlayerElapsedTime: 0,
      sessionTitle: "",
      videoPlayerOptions: {
        autoplay: true,
        controls: true,
        controlBar: {
          progressControl: false, // hides the time/progress bar
        },
        loop: false,
        spatialNavigation: {
          enabled: false,
          horizontalSeek: false,
        },
        //"pointer-events": "none",
        // controlBar: {
        //   timeDivider: false,
        //   durationDisplay: true,
        // },
        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
      sessionDetailsPopup: false,
      sessionDetailsKey: 0,
      currentSession: null,
      hide_speaker_enabled: 1,
      isPublicPage: false,
      IsMyAgenda: false,
      showDeleteConfirmDialog: false,
      selectedSessionId: "",
      rtmpDialog: {
        key: 0,
        lastUpdateTimeStamp: 0,
        sessionId: "",
        session: null,

        rtmpOptions: {
          title: "Welcome",
          state: false,
          startProcessing: false,
          stopProcessing: false,
          sessionId: "",
          uid: "",
          event_collectionName: "",

          hasJoinLink: false,
          rtmpStartLink: false,
          rtmpStopLink: false,
          rtmpAudienceLink: false,
          viewersCount: 0,
          zoomUrl: "",
          streamUrl: "",
          MeetingStarted: false,
          RTMPStarted: false,
          chatEnabled: false,
          qnaEnabled: false,
          //attendeeEnabled: false,
        },
      },
      speakerEvent: null,
      ipadScreen: false,
      headerText: "Sessions",
      LiveStageURL: "/livestage",
      StageViewURL: "",
      StageViewEnabled: false,
      ShowMeetingButton: false,
      ShowSendMessageButton: false,
      attendeeData: [],
      sessionTabList: [], //for tab only
      sessionContentList: [], //for sesssion content
      sessionListForPopup: [],
      speakerDetailsForPopup: [],
      eventId: "",
      eventName: "",
      userid: "",
      name: "",
      email: "",
      firstName: "",
      lastName: "",
      timeZone: "",
      allSpeakers: [],
      allTracks: [],
      GlobalKeysData: {
        IsOpenInternalPlayer: 1,
        IsBroadcastInNewTab: 1,
        IsVideoInNewTab: 0,
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
        CustomUrlTypeID: 5,
        InPersonTypeID: 6,
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
      },
      clientID: this.$store.getters.getClient[0].id,
      //eventcollection:
      //  this.$store.getters.getEventCollection.eventcollectionname,
      eventcollection: "",

      spkrLimit: 5,
      //isSpeakerUser: false
      textColor: "black",
      allSessions: [],
      mySessions: [],
      sessionsLoaded: false,
      sessionSettingsLoaded: false,
      mySessionsLoaded: false,
      selectedAgendaType: 0, // 0:FULL AGENDA, 1:MY AGENDA
      AgendaFilterOption: 0, // 0: FullAgendaOnly (Default), 1: MyAgendaOnly, 2: ShowAll
      AllowAddRemoveMyAgenda: false,
      CustomURLSessionLiveBeforeMinutes: 0,
      selectedTabId: "",
      selectedStartDate: null,
      selectedEndDate: null,
      //tabObjList: [],
      dateTabs: [],
      selectedTabSessions: [],
      tempSession: null,
      selectedDateValue: null,
      IsZoomRTMPOptionsEnabled: false,
      IsRTMPEnabled: false,
      RestrictedZoomMeetingEnabled: true,
      loaderFlg: false,
      trackId: "",
      trackName: "",
      localTimeZone: "",
      isMobileView: true,
      hooperSettings: {
        vertical: false,
        autoPlay: false,
        centerMode: true,
        itemsToShow: 2,
        itemsToSlide: 1,
        mouseDrag: true,
        wheelControl: false,
        keysControl: false,
        shortDrag: false,
        breakpoints: {
          0: {
            itemsToShow: 2.5,
          },
          300: {
            itemsToShow: 3.5,
          },
          400: {
            itemsToShow: 4,
          },
          768: {
            itemsToShow: 6,
          },
          1024: {
            itemsToShow: 8,
          },
          1366: {
            itemsToShow: 10,
          },
          1440: {
            itemsToShow: 12,
          },
          4000: {
            itemsToShow: 14,
          },
        },
      },
      AgoraPlayerBrowserSupportInMobile: true,
      AgoraPlayerBrowserSupportInIPad: true,
    };
  },
  computed: {
    videoPlayer() {
      return self.$refs.videoPlayer.player;
    },
    rtmpComponent() {
      return self.$refs.rtmpComponent.rtmpComp;
    },
  },
  watch: {
    "rtmpDialog.lastUpdateTimeStamp"() {
      if (self.rtmpDialog.session) {
        let session = self.rtmpDialog.session;
        self.rtmpDialog.rtmpOptions.hasJoinLink = false;
        self.rtmpDialog.rtmpOptions.rtmpStartLink = false;
        self.rtmpDialog.rtmpOptions.rtmpStopLink = false;
        self.rtmpDialog.rtmpOptions.rtmpAudienceLink = false;
        self.rtmpDialog.rtmpOptions.MeetingStarted = session.MeetingStarted;
        self.rtmpDialog.rtmpOptions.RTMPStarted = session.RTMPStarted;
        if (session.IsZoomRTMP) {
          if (session.IsHost || session.IsSpeaker) {
            self.rtmpDialog.rtmpOptions.hasJoinLink = true;
          }
          if (session.IsHost) {
            self.rtmpDialog.rtmpOptions.rtmpStartLink = true;
          }
          if (session.IsHost && session.RTMPStarted) {
            self.rtmpDialog.rtmpOptions.rtmpStopLink = true;
          }
          if (session.RTMPStarted) {
            self.rtmpDialog.rtmpOptions.rtmpAudienceLink = true;
          }
        }
      }
    },
    speakerEvent(val) {
      if (val) {
        this.$store.commit("addEventCollection", val.iceId);
        this.$store.commit("addEventID", val.EventId);
        this.getSessions();
      }
    },
    selectedAgendaType: function () {},
    selectedTabId: function () {},
    sessionSettingsLoaded: function () {
      if (self.sessionsLoaded && self.mySessionsLoaded) {
        self.initAgendaFilterOption();
      }
    },
    sessionsLoaded: function () {
      if (self.sessionSettingsLoaded && self.mySessionsLoaded) {
        self.initAgendaFilterOption();
      }
    },
    mySessionsLoaded: function () {
      if (self.sessionsLoaded && self.sessionSettingsLoaded) {
        self.initAgendaFilterOption();
      }
    },
  },
  beforeCreate() {
    //if (!self) {
    //  self = this;
    //}
  },
  created() {
    self = this;
    self.isMobileView = self.isMobile();
    $(window).resize(function () {
      self.isMobileView = self.isMobile();
    });
    if (self.$route.params.tid) {
      self.trackId = self.$route.params.tid;
    }
    if (self.$route.params.tname) {
      self.trackName = self.$route.params.tid;
    }
    self.localTimeZone = common.getTimeZoneName();
  },
  async beforeRouteUpdate(to, from, next) {
    next(true);
    self.trackId = "";
    if (self.$route.params.tid) {
      self.trackId = self.$route.params.tid;
    }
    self.trackName = "";
    if (self.$route.params.tname) {
      self.trackName = self.$route.params.tid;
    }
    self.getSessions();
  },
  async mounted() {
    var data = {
      showUserWelcomeLoader: false,
    };

    bus.$emit("setUserWelcomeLoader", data);
    self.getSessions();
  },
  beforeDestroy() {
    self.speakerDetailsForPopup = [];
    self.allSpeakers = [];
    self.searchtext = "";

    if (sessionStatusRefreshTimer) {
      clearInterval(sessionStatusRefreshTimer);
    }
    if (zoomRTMPRefreshTimer) {
      clearInterval(zoomRTMPRefreshTimer);
    }
    if (ZoomRTMPParticipantsListener) {
      ZoomRTMPParticipantsListener();
      ZoomRTMPParticipantsListener = null;
    }
  },
  methods: {
    showVideoPlayer(onDemandVideo) {
      debugger;
      console.log("showVideoPlayer");
      var playList = [];
      // onDemandVideo = [
      //   "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT_C1649103310659E1753782549628%2F2.%20New%20welcome%20to%20Arabia%20Video%20STA_1920x1080_H.mp4?alt=media&token=872c4d66-c7ef-4966-ad0f-f7cf7c69fd25",
      //   "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT_C1649103310659E1753782549628%2F2.%20New%20welcome%20to%20Arabia%20Video%20STA_1920x1080_H.mp4?alt=media&token=872c4d66-c7ef-4966-ad0f-f7cf7c69fd25",
      // ];
      if (onDemandVideo && onDemandVideo.length > 0) {
        onDemandVideo.forEach(function (item) {
          var type = "application/x-mpegurl";
          // type = "video/mp4";
          // if (item.type) {
          //   type = item.type;
          // } else {
          //   if (item.url && item.url.toLowerCase().endsWith(".mp4")) {
          //     type = "video/mp4";
          //   }
          // }
          //alert(item);
          playList.push({
            sources: [
              {
                src: item,
                type: type,
              },
            ],
            // poster: "http://media.w3.org/2010/05/sintel/poster.png",
          });
        });
        if (playList.length > 0) {
          self.videoPlayerDialog = true;
          self.$nextTick(() => {
            // videoPlayerElapsedTime = parseInt(videoPlayerElapsedTime);
            self.videoPlayer.playlist(playList);
            self.videoPlayer.playlist.autoadvance(0);
            // videoPlayerElapsedTime -= 5;
            // if (videoPlayerElapsedTime < 0) {
            //   videoPlayerElapsedTime = 0;
            // }
            // self.videoPlayer.currentTime(videoPlayerElapsedTime);
            self.videoPlayer.currentTime(0);
            self.videoPlayer.play();
            // self.videoPlayer.playlist(playList);
          });
        }
      }
    },
    onVideoPlayerEnded() {
      //player
      self.videoPlayerDialog = false;
      // if (player) {
      //   document.cookie = "welcomeVideoSeen" + self.todaysDate + "=true";
      // }
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
      } catch (e) {
        console.log(e);
      }
      // if (self.welcomeVideo.RedirectOnEnd) {
      //   router.push(self.welcomeVideo.RedirectToUrl || "/sessions");
      // }
    },
    onVideoPlayerTimeUpdate() {
      //player
      // // alert("onVideoPlayerTimeUpdate");
      // let time = Math.floor(player.currentTime());
      // if (time > self.videoPlayerElapsedTime) {
      //   self.videoPlayerElapsedTime = time;
      //   console.log(self.videoPlayerElapsedTime);
      //   document.cookie =
      //     "videoPlayerElapsedTime" +
      //     self.todaysDate +
      //     "=" +
      //     self.videoPlayerElapsedTime;
      //   // End Video Play
      //   // var welcomeVideoStartTime = self.welcomeVideo.StartTime.seconds * 1000;
      //   var welcomeVideoEndTime = self.welcomeVideo.EndTime.seconds * 1000;
      //   var currentTime = new Date().getTime();
      //   if (currentTime > welcomeVideoEndTime) {
      //     self.videoPlayer.pause();
      //     self.onVideoPlayerEnded({});
      //   }
      // }
    },
    closeVideoPlayer() {
      self.videoPlayerDialog = false;
      self.videoPlayer.pause();
      self.onVideoPlayerEnded();
    },
    visibleSessionSpeakers(mappedSpeakers) {
      var speakers = [];
      speakers = mappedSpeakers.filter(function (item) {
        return !item.HideInList;
      });
      return speakers;
    },
    DisplaySessionDetails(session) {
      self.sessionDetailsKey++;
      self.sessionDetailsPopup = true;
      self.IsMyAgenda = self.mySessions.includes(session.SessionId);
      self.currentSession = session;
    },
    OpenAddSessionPopup(typeId, typeName, sessionId) {
      console.log(typeId);
      //self.$emit("OpenAddSessionPopup", {typeId:typeId});
      self.$emit(
        "OpenAddSessionPopup",
        { typeId: typeId, typeName: typeName },
        sessionId
      );
    },
    async getSessions() {
      self.allSessions = [];
      self.mySessions = [];
      self.selectedTabSessions = [];
      self.sessionsLoaded = false;
      self.sessionSettingsLoaded = false;
      self.mySessionsLoaded = false;
      self.sessionContentList = [];
      db.collection("OA_UAT")
        .doc("GeneralSettings")
        .get()
        .then(function (doc) {
          if (doc.exists) {
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.IsZoomRTMPOptionsEnabled
            ) {
              self.IsZoomRTMPOptionsEnabled =
                doc.data().PlayerSettings.IsZoomRTMPOptionsEnabled;
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.IsRTMPEnabled
            ) {
              self.IsRTMPEnabled = doc.data().PlayerSettings.IsRTMPEnabled;
            }
          }
        });
      if (screen.width >= 768 && screen.width <= 1024) {
        self.ipadScreen = true;
        common.checkAppDownloadScreenByDevice("ipad");
      } else if (screen.width < 767) {
        common.checkAppDownloadScreenByDevice("mobile");
      }
      self.ShowMeetingButton = false;
      self.ShowSendMessageButton = false;
      /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      common.toggleTopMenu(true);
      common.toggleLeftMenu(true);
      $("#btnAddUserView").click();
      if (obj) {
        self.eventcollection = obj.eventcollectionname;
        self.eventName = obj.eventname;
        self.eventId = obj.eventid;
        if (obj.user && obj.user.length > 0) {
          self.name = obj.user[0].name;
          self.email = obj.user[0].Email;
          self.firstName = obj.user[0].fname;
          self.lastName = obj.user[0].lname;
          self.userid = obj.user[0].id;
          self.timeZone = obj.tzone;
        }
        if (obj.AgoraPlayerBrowserSupportInMobile != undefined) {
          self.AgoraPlayerBrowserSupportInMobile =
            obj.AgoraPlayerBrowserSupportInMobile;
        }
        if (obj.AgoraPlayerBrowserSupportInIPad != undefined) {
          self.AgoraPlayerBrowserSupportInIPad =
            obj.AgoraPlayerBrowserSupportInIPad;
        }
      }
      if (!self.eventcollection) {
        self.eventcollection = self.eventCollectionName;
      }
      if (!self.eventName) {
        self.eventName = self.eventFullName;
      }
      if (!self.timeZone) {
        self.timeZone = self.eventTimeZone;
      }
      if (self.eventcollection) {
        db.collection(self.eventcollection)
          .doc("Settings")
          .collection("Sessions")
          .doc("SessionsSettings")
          .get()
          .then((doc) => {
            if (doc.exists) {
              var data = doc.data();
              if (data.AgendaFilterOption != undefined) {
                self.AgendaFilterOption = parseInt(data.AgendaFilterOption);
              }
              if (data.AllowAddRemoveMyAgenda != undefined) {
                self.AllowAddRemoveMyAgenda = data.AllowAddRemoveMyAgenda;
              }
              if (data.CustomURLSessionLiveBeforeMinutes) {
                self.CustomURLSessionLiveBeforeMinutes =
                  data.CustomURLSessionLiveBeforeMinutes;
              }
              if (data.PlayOnDemandVideoOnPopup) {
                self.PlayOnDemandVideoOnPopup = data.PlayOnDemandVideoOnPopup;
              }
            }
            if (self.AgendaFilterOption == 0) {
              self.mySessionsLoaded = true;
            } else {
              self.prepareMySession();
            }
            self.sessionSettingsLoaded = true;
          })
          .catch((error) => {
            console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>" + error);
          });
      }
      //-------------dynamic font selection --------------------------------------
      if (obj && obj.EventFont != undefined && obj.EventFont.length > 0) {
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }

      //Dynamic font selection
      if (obj && obj.EventBranding && obj.EventBranding.length > 0) {
        $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
        if (!self.isAdminComponent) {
          $("#sectionId").css(
            "background-image",
            "url(" + obj.EventBranding[0].eventBGImage + ")"
          );
        }
      }

      //FAVICONJOB
      if (
        obj &&
        obj.branding &&
        obj.branding.length > 0 &&
        obj.branding[0].favicon
      ) {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }

      //Page Title
      //self.headerText = "Sessions";
      db.collection(self.eventcollection)
        .doc("Menu")
        .get()
        .then((doc) => {
          var data = doc.data();
          $.each(data.AllMenu, function (key, value) {
            if (value.GroupID != 99) {
              debugger;
              if (value.Name == "Sessions") {
                if (self.$store.state.locale == "English") {
                  self.headerText = value.DisplayLabel;
                } else if (self.$store.state.locale == "German") {
                  self.headerText = value.DisplayLabel_de;
                } else if (self.$store.state.locale == "French") {
                  self.headerText = value.DisplayLabel_fr;
                } else if (self.$store.state.locale == "Chinese") {
                  self.headerText = value.DisplayLabel_zh;
                } else if (self.$store.state.locale == "Spanish") {
                  self.headerText = value.DisplayLabel_es;
                } else {
                  self.headerText = value.DisplayLabel;
                }
                document.title = self.headerText + " - " + self.eventName;
              }
              if (value.MenuID == 1022) {
                self.LiveStageURL = value.PageUrl
                  ? value.PageUrl
                  : "/livestage";
              }
              if (value.MenuID == 1030) {
                self.StageViewURL = value.PageUrl
                  ? value.PageUrl
                  : "/stageview";
                if (value.StageViewEnabled) {
                  self.StageViewEnabled = true;
                }
              }
            }
          });
          $.each(data.LeftMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Sessions") {
                if (self.$store.state.locale == "English") {
                  self.headerText = value.DisplayLabel;
                } else if (self.$store.state.locale == "German") {
                  self.headerText = value.DisplayLabel_de;
                } else if (self.$store.state.locale == "French") {
                  self.headerText = value.DisplayLabel_fr;
                } else if (self.$store.state.locale == "Chinese") {
                  self.headerText = value.DisplayLabel_zh;
                } else if (self.$store.state.locale == "Spanish") {
                  self.headerText = value.DisplayLabel_es;
                } else {
                  self.headerText = value.DisplayLabel;
                }
                document.title = self.headerText + " - " + self.eventName;
              }
              if (value.MenuID == 1022) {
                self.LiveStageURL = value.PageUrl
                  ? value.PageUrl
                  : "/livestage";
              }
              if (value.MenuID == 1030) {
                self.StageViewURL = value.PageUrl
                  ? value.PageUrl
                  : "/stageview";
                if (value.StageViewEnabled) {
                  self.StageViewEnabled = true;
                }
              }
            }
          });
        });

      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          self.eventcollection + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          if (brandingData.data.EventInfo != undefined) {
            if (brandingData.data.EventInfo.BodyTextColor != undefined) {
              self.textColor = brandingData.data.EventInfo.BodyTextColor;
            } else {
              self.textColor = "black";
            }
          } else {
            self.textColor = "black";
          }
          console.log("BodyTextColor :- " + self.textColor);
          if (!self.isAdminComponent) {
            if ($("#headerText")) {
              $("#headerText").css("color", self.textColor);
            }
          }
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }

      self.scroll();
      self.loadAllSessions();
      self.setFirebaseAppsettings();
      self.getSpeakerSettings();
    },
    getWidth() {
      let width = document.getElementById("leftmenu")
        ? document.getElementById("ulLeftMenu").offsetWidth
        : 0;
      return `width:calc(100% - ${width}px) !important`;
    },
    rowClassCss(index) {
      if (index < 2) return "row main-divider my-0 py-0 mr-2";
      else return "row main-divider my-0 py-0";
    },
    hiddenTrackClass(option, sessionRow, index) {
      var result = "";
      if (option == 1) {
        result = "time-location";
      } else if (option == 2) {
        result = "track-box track-box-continue";
      }
      if (!sessionRow[index].Track.TrackName) {
        if (option == 1) {
          if (
            sessionRow.length == 1 ||
            (sessionRow.length == 2 &&
              !sessionRow[index + 1].Track.TrackName) ||
            (sessionRow.length >= 3 &&
              !sessionRow[index + 1].Track.TrackName &&
              !sessionRow[index + 2].Track.TrackName)
          ) {
            result += " no-track";
          }
        } else if (option == 2) {
          result += " empty-track";
        }
        if (option == 2) {
          // if ([12, 13].includes(index)) {
          //   debugger;
          // }
          var index1 = -1;
          var index2 = -1;
          var index3 = -1;
          var trackIndex = index % 3;
          if (trackIndex == 0) {
            if (sessionRow.length > index) {
              index1 = index;
            }
            if (sessionRow.length > index + 1) {
              index2 = index + 1;
            }
            if (sessionRow.length > index + 2) {
              index3 = index + 2;
            }
          } else if (trackIndex == 1) {
            if (sessionRow.length > index - 1) {
              index1 = index - 1;
            }
            if (sessionRow.length > index) {
              index2 = index;
            }
            if (sessionRow.length > index + 1) {
              index3 = index + 1;
            }
          } else if (trackIndex == 2) {
            if (sessionRow.length > index - 2) {
              index1 = index - 2;
            }
            if (sessionRow.length > index - 1) {
              index2 = index - 1;
            }
            if (sessionRow.length > index) {
              index3 = index;
            }
          }
          //if (
          //  !sessionRow[index1] ||
          //  !sessionRow[index2] ||
          //  !sessionRow[index3]
          //) {
          //  debugger;
          //}
          if (index1 > -1 && index2 > -1 && index3 > -1) {
            if (
              !sessionRow[index1].Track.TrackName &&
              !sessionRow[index2].Track.TrackName &&
              !sessionRow[index3].Track.TrackName
            ) {
              result += " d-none";
            }
          } else if (index1 > -1 && index2 > -1) {
            if (
              !sessionRow[index1].Track.TrackName &&
              !sessionRow[index2].Track.TrackName
            ) {
              result += " d-none";
            }
          } else if (index1 > -1) {
            if (!sessionRow[index1].Track.TrackName) {
              result += " d-none";
            }
          }
        }
      }
      return result;
    },
    trackColor(trackId) {
      let color = "";
      let track = self.allTracks.filter(function (item) {
        return item.TrackId == trackId;
      });
      if (track.length > 0) {
        color = track[0].ColorCode ? track[0].ColorCode : "#d7d7ea";
      }
      return color;
    },
    addToMyAgenda(sessionId) {
      $("#addToMyAgenda_" + sessionId).html("Processing...");
      $("#addToMyAgenda_" + sessionId).attr("disabled");
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let attendees = [
        {
          AttendeeId: self.userid,
          Email: self.email,
          FirstName: self.firstName,
          LastName: self.lastName,
          Name: self.name,
        },
      ];
      let currentSessions = self.allSessions.filter(function (item) {
        return item.SessionId == sessionId;
      });
      if (currentSessions.length > 0) {
        let sessions = [
          {
            EndDate: new Date(
              currentSessions[0].EndDate.seconds * 1000
            ).toUTCString(),
            Name: currentSessions[0].Name,
            SessionId: sessionId,
            StartDate: new Date(
              currentSessions[0].StartDate.seconds * 1000
            ).toUTCString(),
            Track: currentSessions[0].Track,
          },
        ];
        let requestData = {
          source: "web",
          //"token": accessToken,
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventId,
          },
          data: {
            sessions: sessions,
            map: {
              attendees: attendees,
              groups: [],
            },
            unmap: {
              attendees: [],
              groups: [],
            },
          },
        };
        axios
          .put(APIs.SessionAttendeeMappingAPI, requestData, {
            headers: headers,
          })
          .then((response) => {
            //alert(response);
            console.log(response);
            if (!self.mySessions.includes(sessionId)) {
              self.mySessions.push(sessionId);
            }
            $("#addToMyAgenda_" + sessionId).html("Remove from My Agenda");
            $("#addToMyAgenda_" + sessionId).removeAttr("disabled");
            self.setupCurrentTabs();
            self.setupCurrentTabSessions();
            self.sessionDetailsKey++;
            self.IsMyAgenda = self.mySessions.includes(sessionId);
          })
          .catch((error) => {
            console.log(error);
            $("#addToMyAgenda_" + sessionId).html("Add to My Agenda");
            $("#addToMyAgenda_" + sessionId).removeAttr("disabled");
          });
      }
    },
    removeFromMyAgenda: function (sessionId) {
      $("#removeFromMyAgenda_" + sessionId).html("Processing...");
      $("#removeFromMyAgenda_" + sessionId).attr("disabled");
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let attendees = [
        {
          AttendeeId: self.userid,
          Email: self.email,
          FirstName: self.firstName,
          LastName: self.lastName,
          Name: self.name,
        },
      ];
      let currentSessions = self.allSessions.filter(function (item) {
        return item.SessionId == sessionId;
      });
      if (currentSessions.length > 0) {
        let sessions = [
          {
            EndDate: new Date(
              currentSessions[0].EndDate.seconds * 1000
            ).toUTCString(),
            Name: currentSessions[0].Name,
            SessionId: sessionId,
            StartDate: new Date(
              currentSessions[0].StartDate.seconds * 1000
            ).toUTCString(),
            Track: currentSessions[0].Track,
          },
        ];
        let requestData = {
          source: "web",
          //"token": accessToken,
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventId,
          },
          data: {
            sessions: sessions,
            map: {
              attendees: [],
              groups: [],
            },
            unmap: {
              attendees: attendees,
              groups: [],
            },
          },
        };
        axios
          .put(APIs.SessionAttendeeMappingAPI, requestData, {
            headers: headers,
          })
          .then((response) => {
            console.log(response);
            if (self.mySessions.includes(sessionId)) {
              self.mySessions = self.mySessions.filter(function (val) {
                return val != sessionId;
              });
              if (self.mySessions.length == 0 && self.selectedAgendaType == 1) {
                self.selectedAgendaType = 0;
              }
            }
            $("#removeFromMyAgenda_" + sessionId).html("Add to My Agenda");
            $("#removeFromMyAgenda_" + sessionId).removeAttr("disabled");
            self.setupCurrentTabs();
            self.setupCurrentTabSessions();
            self.sessionDetailsKey++;
            self.IsMyAgenda = self.mySessions.includes(sessionId);
          })
          .catch((error) => {
            console.log(error);
            $("#removeFromMyAgenda_" + sessionId).html("Remove from My Agenda");
            $("#removeFromMyAgenda_" + sessionId).removeAttr("disabled");
          });
      }
    },
    initAgendaFilterOption: function () {
      if (self.AgendaFilterOption == 0 || self.AgendaFilterOption == 2) {
        self.selectedAgendaType = 0;
      } else if (self.AgendaFilterOption == 1) {
        self.selectedAgendaType = 1;
      }
      self.setupCurrentTabs();
      bus.$emit("toggleLoader", false);
      setTimeout(() => {
        if (sessionStatusRefreshTimer) {
          clearInterval(sessionStatusRefreshTimer);
        }
        sessionStatusRefreshTimer = setInterval(function () {
          if (self.sessionContentList.length > 0) {
            self.updateSessionStatus();
          }
        }, 2000);
      }, 5000);
    },
    onAgendaTypeChanged(agendaType) {
      self.selectedAgendaType = agendaType;
      //self.selectedStartDate = null;
      //self.selectedEndDate = null;
      self.setupCurrentTabs();
    },
    afterSlideTab(arg) {
      if (arg && arg.currentSlide) {
        var index = arg.currentSlide;
        self.onTabChange(
          self.dateTabs[index].DateTabId,
          self.dateTabs[index].StartTime,
          self.dateTabs[index].EndTime
        );
      }
    },
    onTabChange: function (tabId, startDate, endDate) {
      self.selectedTabId = tabId;
      self.selectedStartDate = startDate;
      self.selectedEndDate = endDate;

      setTimeout(() => {
        self.setupCurrentTabSessions();
        if (self.isMobileView) {
          for (var i = 0; i < self.dateTabs.length; i++) {
            if (self.dateTabs[i].DateTabId == tabId) {
              self.$refs.hooperSlide.slideTo(i);
              break;
            }
          }
        }
        //hooper.update()
        //alert("update");
      }, 100);
    },
    mobileDropdownChange() {
      console.log("sd========", self.selectedDateValue);
      console.log("dt========", self.dateTabs);
      self.dateTabs.filter(function (tab) {
        if (tab.DateTabId == self.selectedDateValue) {
          self.onTabChange(tab.DateTabId, tab.StartTime, tab.EndTime);
        }
      });
    },
    setupCurrentTabs() {
      let tabList = [];
      let tabObjList = [];
      self.allSessions.forEach(function (item) {
        let flag = true;
        if (
          (self.AgendaFilterOption == 1 || self.AgendaFilterOption == 2) &&
          self.selectedAgendaType == 1
        ) {
          flag = false;
          if (self.mySessions.includes(item.SessionId)) {
            flag = true;
          }
        }
        if (flag) {
          let dtt = new Date(item.StartTime * 1000);
          var dtYear = dtt.getFullYear();
          var dtMonth = dtt.getMonth();
          var dtDay = dtt.getDate();
          let startDate = new Date(dtYear, dtMonth, dtDay);
          dtt = new Date((item.EndTime - 1) * 1000);
          dtYear = dtt.getFullYear();
          dtMonth = dtt.getMonth();
          dtDay = dtt.getDate();
          //let endDate = new Date(dtYear, dtMonth, dtDay, 23, 59, 59);
          let endDate = new Date(dtYear, dtMonth, dtDay + 1, 0, 0, 0);

          while (startDate < endDate) {
            let dateTabLabel = startDate.toString().substring(0, 10);
            if (!tabList.includes(dateTabLabel)) {
              tabList.push(dateTabLabel);
              let dateTabId =
                "menu" + dateTabLabel.replace(" ", "").replace(" ", "");

              let tabObj = {
                DateTabLabel: dateTabLabel,
                DateTabId: dateTabId,
                CurrentClass: "",
                StartTime: parseInt(startDate.getTime() / 1000),
                SDT: startDate.toString(),
              };
              startDate.setDate(startDate.getDate() + 1);
              tabObj.EndTime = parseInt(startDate.getTime() / 1000);
              tabObj.EDT = startDate.toString();
              tabObjList.push(tabObj);
              console.log(tabObj);
            } else {
              startDate.setDate(startDate.getDate() + 1);
            }
          }
          //if (!tabList.includes(item.DateTabLabel)) {
          //  tabList.push(item.DateTabLabel);

          //  let dateTabId =
          //    "menu" + item.DateTabLabel.replace(" ", "").replace(" ", "");

          //  tabObjList.push({
          //    DateTabLabel: item.DateTabLabel,
          //    DateTabId: dateTabId,
          //    CurrentClass: "",
          //  });

          //  //tbObj.StartDate = new Date(dtYear, dtMonth, dtDay);

          //  //tbObj.StartTime = tbObj.StartDate.getTime();
          //  //tbObj.EndDate = new Date(dtYear, dtMonth, dtDay);
          //  //tbObj.EndDate.setDate(tbObj.EndDate.getDate() + 1);
          //  //tbObj.EndTime = tbObj.EndDate.getTime();
          //  //tbObj.CurrentClass = "";
          //}

          //}
        }
      });

      tabObjList.map(function (tab) {
        tab.CurrentClass = "";
      });

      tabObjList.map(function (tab) {
        if (tab.DateTabId == self.selectedTabId) {
          tab.CurrentClass = "active";
        }
      });
      var selectedTabs = tabObjList.filter(function (tab) {
        return tab.DateTabId == self.selectedTabId;
      });
      if (selectedTabs.length == 0) {
        let currentTime = parseInt(new Date().getTime() / 1000);

        var tabSelected = false;
        var tIndx = 0;
        var todaysTab = tabObjList.filter(function (tab) {
          return currentTime >= tab.StartTime && currentTime < tab.EndTime;
        });
        if (todaysTab.length > 0) {
          for (tIndx = 0; tIndx < tabObjList.length; tIndx++) {
            if (
              currentTime >= tabObjList[tIndx].StartTime &&
              currentTime <= tabObjList[tIndx].EndTime
            ) {
              tabObjList[tIndx].CurrentClass = "active";
              //self.sessionContentList[tIndx].CurrentClass = "active";
              tabSelected = true;
              //self.selectedStartDate = tabObjList[tIndx].StartTime;
              //self.selectedEndDate = tabObjList[tIndx].EndTime;
              break;
            }
          }
        }

        if (!tabSelected) {
          var upCommingTab = tabObjList.filter(function (tab) {
            return currentTime < tab.StartTime;
          });
          if (upCommingTab.length > 0) {
            for (tIndx = 0; tIndx < tabObjList.length; tIndx++) {
              if (currentTime < tabObjList[tIndx].StartTime) {
                tabObjList[tIndx].CurrentClass = "active";
                //self.sessionContentList[tIndx].CurrentClass = "active";
                tabSelected = true;
                //self.selectedStartDate = tabObjList[tIndx].StartTime;
                //self.selectedEndDate = tabObjList[tIndx].EndTime;
                break;
              }
            }
          }
        }

        if (!tabSelected) {
          var finishedTab = tabObjList.filter(function (tab) {
            return currentTime > tab.EndTime;
          });
          if (finishedTab.length > 0) {
            for (tIndx = tabObjList.length - 1; tIndx >= 0; tIndx--) {
              if (currentTime > tabObjList[tIndx].EndTime) {
                tabObjList[tIndx].CurrentClass = "active";
                //self.sessionContentList[tIndx].CurrentClass = "active";
                tabSelected = true;
                //self.selectedStartDate = tabObjList[tIndx].StartTime;
                //self.selectedEndDate = tabObjList[tIndx].EndTime;
                break;
              }
            }
          }
        }
      }
      selectedTabs = tabObjList.filter(function (tab) {
        return tab.CurrentClass == "active";
      });
      if (selectedTabs.length > 0) {
        self.onTabChange(
          selectedTabs[0].DateTabId,
          selectedTabs[0].StartTime,
          selectedTabs[0].EndTime
        );
      }
      self.dateTabs = tabObjList;
    },
    setupCurrentTabSessions() {
      let sessionContentList = [];
      let sessionTabList = [];
      self.selectedTabSessions = [];
      //var testFlag = false;
      self.allSessions.forEach(function (item) {
        let flag = true;
        if (
          (self.AgendaFilterOption == 1 || self.AgendaFilterOption == 2) &&
          self.selectedAgendaType == 1
        ) {
          flag = false;
          if (self.mySessions.includes(item.SessionId)) {
            flag = true;
          }
        }
        if (flag) {
          // if(["99913111","99904337","99904338"].includes(item.SessionId))
          // {
          //   testFlag = true;
          //   //alert("sddddddddddddd")
          //   //debugger;
          // }
          // if (testFlag) {
          //     //debugger;
          // }
          if (
            (item.StartTime < self.selectedStartDate &&
              item.EndTime > self.selectedEndDate) ||
            (item.StartTime >= self.selectedStartDate &&
              item.StartTime <= self.selectedEndDate) ||
            (item.EndTime >= self.selectedStartDate &&
              item.EndTime <= self.selectedEndDate)
          ) {
            var dateTabLabel;
            let dtt = new Date(self.selectedStartDate * 1000);
            var dtYear = dtt.getFullYear();
            var dtMonth = dtt.getMonth();
            var dtDay = dtt.getDate();
            dateTabLabel = dtt.toString().substring(0, 10);
            let tabStartTime = parseInt(
              new Date(dtYear, dtMonth, dtDay).getTime() / 1000
            );
            let tabEndDate = new Date(dtYear, dtMonth, dtDay);
            tabEndDate.setDate(tabEndDate.getDate() + 1);
            let tabEndTime = parseInt(tabEndDate.getTime() / 1000);
            let sessionStartTime = item.StartTime;
            let sessionEndTime = item.EndTime;
            if (sessionStartTime < tabStartTime) {
              sessionStartTime = tabStartTime;
            }
            if (sessionEndTime > tabEndTime) {
              sessionEndTime = tabEndTime;
            }
            if (sessionEndTime - sessionStartTime > 0) {
              var sessionTab = sessionTabList.filter(function (value) {
                return value.DateTabLabel == dateTabLabel;
              });
              if (sessionTab.length == 0) {
                var tbObj = new Object();

                tbObj.DateTabLabel = dateTabLabel;
                tbObj.DateTabId =
                  "menu" + tbObj.DateTabLabel.replace(" ", "").replace(" ", "");
                tbObj.StartDate = new Date(dtYear, dtMonth, dtDay);
                tbObj.StartTime = parseInt(tbObj.StartDate.getTime() / 1000);
                tbObj.EndDate = new Date(dtYear, dtMonth, dtDay);
                tbObj.EndDate.setDate(tbObj.EndDate.getDate() + 1);
                tbObj.EndTime = parseInt(tbObj.EndDate.getTime() / 1000);
                tbObj.CurrentClass = "";
                sessionTabList.push(tbObj);
                var sessionContentObj = new Object();
                sessionContentObj.DateTabLabel = dateTabLabel;
                sessionContentObj.DateTabId =
                  "menu" +
                  sessionContentObj.DateTabLabel.replace(" ", "").replace(
                    " ",
                    ""
                  );
                sessionContentObj.CurrentClass = "";
                sessionContentObj.SessionRowList = [];
                sessionContentList.push(sessionContentObj);
              }
              var sessionContents = sessionContentList.filter(function (value) {
                return value.DateTabLabel == dateTabLabel;
              });
              if (sessionContents.length != 0) {
                var sessionTabIndex = sessionContentList.indexOf(
                  sessionContents[0]
                );
                var filteredRows = sessionContentList[
                  sessionTabIndex
                ].SessionRowList.filter(function (value) {
                  return (
                    value.TodaysStartTime == sessionStartTime &&
                    value.TodaysEndTime == sessionEndTime &&
                    value.ShowInSeparateRow == item.ShowInSeparateRow &&
                    value.ShowBeforeConcurrentSessions ==
                      item.ShowBeforeConcurrentSessions
                  );
                });
                // if(["99913111","99904337","99904338"].includes(item.SessionId)){
                //   //debugger;
                // }
                //if (filteredRows.length > 0 && !item.ShowInSeparateRow && !filteredRows[0].ShowInSeparateRow) {
                if (filteredRows.length > 0) {
                  // if(["99913111","99904337","99904338"].includes(item.SessionId)){
                  //   //debugger;
                  // }
                  filteredRows[0].SessionCollection.push(item);
                } else {
                  //if (filteredRows.length == 0) {
                  var objRow = new Object();
                  objRow.ShowInSeparateRow = item.ShowInSeparateRow;
                  objRow.ShowBeforeConcurrentSessions =
                    item.ShowBeforeConcurrentSessions;
                  objRow.StartTime = item.StartTime;
                  objRow.StartTimeLabel =
                    self.getFormattedTime(sessionStartTime);
                  objRow.EndTime = item.EndTime;
                  objRow.TodaysStartTime = sessionStartTime;
                  objRow.TodaysEndTime = sessionEndTime;
                  objRow.EndTimeLabel = self.getFormattedTime(sessionEndTime);
                  objRow.SessionCollection = [item];
                  // sessionContentList[sessionTabIndex].SessionRowList.push(
                  //   objRow
                  // );

                  if (
                    sessionContentList[sessionTabIndex].SessionRowList.length ==
                      0 ||
                    !item.ShowInSeparateRow ||
                    (item.ShowInSeparateRow &&
                      !item.ShowBeforeConcurrentSessions)
                  ) {
                    sessionContentList[sessionTabIndex].SessionRowList.push(
                      objRow
                    );
                  } else {
                    sessionContentList[sessionTabIndex].SessionRowList.splice(
                      sessionContentList[sessionTabIndex].SessionRowList
                        .length - 1,
                      0,
                      objRow
                    );
                  }
                }
              }
            }
          }
        }
      });
      for (var tIndex = 0; tIndex < sessionContentList.length; tIndex++) {
        for (
          var rIndex = 0;
          rIndex < sessionContentList[tIndex].SessionRowList.length;
          rIndex++
        ) {
          var rowSessCnt =
            sessionContentList[tIndex].SessionRowList[rIndex].SessionCollection
              .length;

          sessionContentList[tIndex].SessionRowList[rIndex].RowSessionCount =
            rowSessCnt;

          //sessionContentList[tIndex].SessionRowList[rIndex].StartTimeLabel =
          //  sessionContentList[tIndex].SessionRowList[
          //    rIndex
          //  ].SessionCollection[0].StartTimeLabel;
          //sessionContentList[tIndex].SessionRowList[rIndex].EndTimeLabel =
          //  sessionContentList[tIndex].SessionRowList[
          //    rIndex
          //  ].SessionCollection[0].EndTimeLabel;
          var sessionResult = sessionContentList[tIndex].SessionRowList[
            rIndex
          ].SessionCollection.filter(function (item) {
            return item.HideTime;
          });
          if (
            sessionResult.length ==
            sessionContentList[tIndex].SessionRowList[rIndex].SessionCollection
              .length
          ) {
            sessionContentList[tIndex].SessionRowList[rIndex].HideTime = true;
          }

          if (rowSessCnt == 1) {
            sessionContentList[tIndex].SessionRowList[rIndex].SessionClass =
              "one-session";

            sessionContentList[tIndex].SessionRowList[rIndex].TrackClass =
              "one-track";
          } else if (rowSessCnt == 2) {
            sessionContentList[tIndex].SessionRowList[rIndex].SessionClass =
              "two-session";
            sessionContentList[tIndex].SessionRowList[rIndex].TrackClass =
              "two-track";
          } else if (rowSessCnt == 3) {
            sessionContentList[tIndex].SessionRowList[rIndex].SessionClass =
              "three-session";
            sessionContentList[tIndex].SessionRowList[rIndex].TrackClass =
              "three-track";
          } else {
            sessionContentList[tIndex].SessionRowList[rIndex].SessionClass =
              "three-session flex-wrap-four";
            sessionContentList[tIndex].SessionRowList[rIndex].TrackClass =
              "three-track";
          }
        }
      }
      self.selectedTabSessions = sessionContentList.filter(function () {
        return true;
      });
      setTimeout(() => {
        $('[data-toggle="tooltip"]').tooltip();
      }, 100);
      setTimeout(() => {
        $('[data-toggle="tooltip"]').tooltip();
      }, 1000);
    },
    goToRTPage(sessionId) {
      $(".tooltip").tooltip("hide");
      $(".modal").modal("hide");
      if (!self.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      router.push({
        path: "/roundtable/" + sessionId,
      });
    },
    GoForInternalPlayer(sessionId, externalLink) {
      $(".tooltip").tooltip("hide");
      $(".modal").modal("hide");
      if (externalLink) {
        if (externalLink.startsWith("/")) {
          router.push(externalLink);
        } else {
          window.open(externalLink, "_blank");
          self.postLeaderboardAction("SNVW");
        }
      } else {
        let sessions = self.allSessions.filter((item) => {
          return item.SessionId == sessionId;
        });
        if (sessions.length > 0) {
          // if (
          //   sessions[0].IsZoomRTMP ||
          //   sessions[0].IsRTMP &&
          //   self.StageViewURL &&
          //   self.StageViewEnabled
          // ) {
          if (
            !(sessions[0].IsHost || sessions[0].IsSpeaker) &&
            self.StageViewURL
          ) {
            router.push({
              path: self.StageViewURL + "/" + sessionId,
            });
          } else {
            router.push({
              path: self.LiveStageURL + "/" + sessionId,
            });
          }
        }
      }
    },
    toggleMoreSessionActions(sessionId, e) {
      if (sessionId) {
        if (
          $("#session_wrap_" + sessionId + " .on-demand-dropdown").hasClass(
            "d-none"
          )
        ) {
          $(".on-demand-dropdown").addClass("d-none");
          $("#session_wrap_" + sessionId + " .on-demand-dropdown").removeClass(
            "d-none"
          );
        } else {
          $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
            "d-none"
          );
        }
      } else {
        $(".on-demand-dropdown").addClass("d-none");
      }
      if (e) {
        e.stopPropagation();
      }
    },
    toggleMoreSessionActions1(sessionId, e) {
      if (sessionId) {
        if ($(e.target).siblings(".on-demand-dropdown").hasClass("d-none")) {
          $(".on-demand-dropdown").addClass("d-none");
          $(e.target).siblings(".on-demand-dropdown").removeClass("d-none");
        } else {
          $(e.target).siblings(".on-demand-dropdown").addClass("d-none");
        }
        if (e) {
          e.stopPropagation();
        }
      } else {
        $(".on-demand-dropdown").addClass("d-none");
      }
    },
    StartRTMPStreaming(sessionId, e) {
      $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
        "d-none"
      );
      var flag = false;
      self.sessionContentList.forEach(function (tab) {
        tab.SessionRowList.forEach(function (row) {
          row.SessionCollection.forEach(function (session) {
            if (session.SessionId == sessionId) {
              if (
                session.SessionTypeDetails.TypeID == 3 &&
                session.IsZoomRTMP
              ) {
                flag = true;
                let headers = {
                  "content-type": "application/json",
                };
                let bodyData = {
                  meetingid: session.Zoom_Detail.id,
                  stream_url:
                    session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.url,
                  stream_key:
                    session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.streamKey,
                  page_url: session.ZoomRTMPMUX_detail.data.playbackUrl,
                };
                bus.$emit("toggleLoader", true);
                axios
                  .post(APIs.EnableZoomRTMPStreaming, bodyData, {
                    headers: headers,
                  })
                  .then((response) => {
                    if (response.data.status == 0) {
                      let headers = {
                        "content-type": "application/json",
                        Authorization: "Bearer " + self.getSessionToken(),
                      };
                      let requestData = {
                        collection: "SessionList/Sessions",
                        instance: self.eventcollection,
                        data: {
                          ZoomRTMPEnable_Status: response.data,
                          RTMPStarted: true,
                          id: sessionId,
                        },
                      };
                      axios
                        .put(APIs.WriteObject, requestData, {
                          headers: headers,
                        })
                        .then((responseData) => {
                          bus.$emit("toggleLoader", false);
                          $(
                            "#session_wrap_" +
                              sessionId +
                              " .on-demand-dropdown"
                          ).addClass("d-none");
                          self.showSnackbar(
                            "RTMP Streaming started successfully.",
                            "info",
                            "top"
                          );
                          console.log(responseData);
                          self.rtmpDialog.rtmpOptions.startProcessing = false;
                        })
                        .catch(function (error) {
                          self.rtmpDialog.rtmpOptions.startProcessing = false;
                          bus.$emit("toggleLoader", false);
                          console.error(
                            "Error updating ZoomRTMPEnable_Status: ",
                            error
                          );
                          self.showSnackbar(
                            "Error on Start RTMP Streaming.",
                            "error",
                            "top"
                          );
                        });
                    } else {
                      self.rtmpDialog.rtmpOptions.startProcessing = false;
                      bus.$emit("toggleLoader", false);
                      self.showSnackbar(
                        "Error on Start RTMP Streaming.",
                        "error",
                        "top"
                      );
                    }
                  })
                  .catch((error) => {
                    self.rtmpDialog.rtmpOptions.startProcessing = false;
                    bus.$emit("toggleLoader", false);
                    console.log(error);
                    self.showSnackbar(
                      "Error on Start RTMP Streaming.",
                      "error",
                      "top"
                    );
                  });
              }
            }
          });
        });
      });
      if (!flag) {
        self.rtmpDialog.rtmpOptions.startProcessing = false;
      }
      if (e) {
        e.stopPropagation();
      }
    },
    StopRTMPStreaming(sessionId, e) {
      $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
        "d-none"
      );
      var flag = false;
      self.sessionContentList.forEach(function (tab) {
        tab.SessionRowList.forEach(function (row) {
          row.SessionCollection.forEach(function (session) {
            if (session.SessionId == sessionId) {
              if (
                session.SessionTypeDetails.TypeID == 3 &&
                session.IsZoomRTMP
              ) {
                flag = true;
                let headers = {
                  "content-type": "application/json",
                };
                let bodyData = {
                  meetingid: session.Zoom_Detail.id,
                };
                bus.$emit("toggleLoader", true);
                axios
                  .post(APIs.DisableZoomRTMPStreaming, bodyData, {
                    headers: headers,
                  })
                  .then((response) => {
                    if (response.data.status == 0) {
                      let headers = {
                        "content-type": "application/json",
                        Authorization: "Bearer " + self.getSessionToken(),
                      };
                      let requestData = {
                        collection: "SessionList/Sessions",
                        instance: self.eventcollection,
                        data: {
                          ZoomRTMPEnable_Status: response.data,
                          RTMPStarted: false,
                          id: sessionId,
                        },
                      };
                      axios
                        .put(APIs.WriteObject, requestData, {
                          headers: headers,
                        })
                        .then((responseData) => {
                          self.rtmpDialog.rtmpOptions.stopProcessing = false;
                          bus.$emit("toggleLoader", false);
                          $(
                            "#session_wrap_" +
                              sessionId +
                              " .on-demand-dropdown"
                          ).addClass("d-none");
                          self.showSnackbar(
                            "RTMP Streaming stopped successfully.",
                            "info",
                            "top"
                          );
                          console.log(responseData);
                        })
                        .catch(function (error) {
                          self.rtmpDialog.rtmpOptions.stopProcessing = false;
                          bus.$emit("toggleLoader", false);
                          console.error(
                            "Error updating ZoomRTMPEnable_Status: ",
                            error
                          );
                          self.showSnackbar(
                            "Error on Stop RTMP Streaming.",
                            "error",
                            "top"
                          );
                        });
                    } else {
                      self.rtmpDialog.rtmpOptions.stopProcessing = false;
                      bus.$emit("toggleLoader", false);
                      self.showSnackbar(
                        "Error on Stop RTMP Streaming.",
                        "error",
                        "top"
                      );
                    }
                  })
                  .catch((error) => {
                    self.rtmpDialog.rtmpOptions.stopProcessing = false;
                    bus.$emit("toggleLoader", false);
                    console.log(error);
                    self.showSnackbar(
                      "Error on Stop RTMP Streaming.",
                      "error",
                      "top"
                    );
                  });
              }
            }
          });
        });
      });
      if (!flag) {
        self.rtmpDialog.rtmpOptions.stopProcessing = false;
      }
      if (e) {
        e.stopPropagation();
      }
    },
    rtmpActions(action, sessionId) {
      let flag = true;
      if (action == 0) {
        self.rtmpDialog.key += 1;
        self.rtmpDialog.sessionId = "";
        self.rtmpDialog.session = null;
        self.rtmpDialog.rtmpOptions.sessionId = "";
        self.rtmpDialog.rtmpOptions.session = null;
        self.rtmpDialog.rtmpOptions.hasJoinLink = false;
        self.rtmpDialog.rtmpOptions.rtmpStartLink = false;
        self.rtmpDialog.rtmpOptions.rtmpStopLink = false;
        self.rtmpDialog.rtmpOptions.rtmpAudienceLink = false;
        self.rtmpDialog.rtmpOptions.viewersCount = 0;
        self.rtmpDialog.rtmpOptions.streamUrl = "";
        self.rtmpDialog.rtmpOptions.zoomUrl = "";
        if (sessionId) {
          let sessions = self.allSessions.filter((item) => {
            return item.SessionId == sessionId;
          });
          if (sessions.length > 0) {
            self.rtmpDialog.sessionId = sessionId;
            self.rtmpDialog.session = sessions[0];
            self.rtmpDialog.rtmpOptions.sessionId = sessionId;
            self.rtmpDialog.rtmpOptions.uid = self.userid;
            self.rtmpDialog.rtmpOptions.event_collectionName =
              self.eventcollection;
            if (sessions[0].IsHost) {
              self.rtmpDialog.rtmpOptions.title = "Welcome Session Host";
            } else if (sessions[0].IsSpeaker) {
              self.rtmpDialog.rtmpOptions.title = "Welcome Session Speaker";
            } else {
              self.rtmpDialog.rtmpOptions.title = "Welcome Session Attendee";
            }
            self.rtmpDialog.rtmpOptions.streamUrl =
              sessions[0].ZoomRTMPMUX_detail.data.playbackUrl;
            self.rtmpDialog.lastUpdateTimeStamp = new Date().getTime();

            self.initParticipantsListener(self.rtmpDialog.sessionId);
          } else {
            flag = false;
          }
        } else {
          flag = false;
        }
      }
      if (flag) {
        if (action == -1) {
          bus.$emit("toggleLoader", false);
          self.rtmpDialog.state = false;
          self.rtmpDialog.key += 1;
          //self.rtmpComponent.stopStreaming();
          if (ZoomRTMPParticipantsListener) {
            ZoomRTMPParticipantsListener();
            ZoomRTMPParticipantsListener = null;
          }
        } else if (action == 0) {
          $(".modal").modal("hide");
          bus.$emit("toggleLoader", false);
          self.rtmpDialog.state = true;
          setTimeout(() => {
            self.rtmpComponent.startStreaming();
          }, 100);
        } else if (action == 1) {
          //self.rtmpDialog.state = false;
          let session = self.rtmpDialog.session;
          if (session) {
            if (session.IsZoomRTMP) {
              if (session.IsZoomRTMP && session.IsHost) {
                window.open(session.Zoom_Detail.start_url, "_blank");
                self.postLeaderboardAction("SNVW");
              } else if (session.IsSpeaker) {
                if (!self.RestrictedZoomMeetingEnabled) {
                  var link =
                    session.Zoom_Detail.join_url +
                    "&uname=" +
                    self.firstName.trim() +
                    "%20" +
                    self.lastName.trim();
                  window.open(link, "_blank");
                  self.postLeaderboardAction("SNVW");
                } else {
                  bus.$emit("toggleLoader", true);
                  let headers = {
                    Authorization: "Bearer " + self.getSessionToken(),
                    "content-type": "application/json",
                  };
                  let requestData = {
                    email: self.email,
                    name: self.name,
                    first_name: self.firstName,
                    last_name: self.lastName,
                    meetingid: session.Zoom_Detail.id,
                    //address: "",
                    //phone: self.phone,
                    //industry: "",
                    //org: self.company,
                    //job_title: self.title,
                  };
                  axios
                    .post(APIs.AddAttendeesToZoom, requestData, {
                      headers: headers,
                    })
                    .then((response) => {
                      if (
                        response &&
                        response.data &&
                        response.data.status == 0 &&
                        response.data.data.id &&
                        response.data.data.join_url &&
                        response.data.data.join_url != ""
                      ) {
                        bus.$emit("toggleLoader", false);
                        window.open(response.data.data.join_url, "_blank");
                        self.postLeaderboardAction("SNVW");
                      } else {
                        bus.$emit("toggleLoader", false);
                        //self.retryJoinInZoomPopup();
                      }
                    })
                    .catch((error) => {
                      bus.$emit("toggleLoader", false);
                      console.log(error);
                      //m.retryJoinInZoomPopup();
                    });
                }
              }
            }
          }
        } else if (action == 2) {
          self.rtmpDialog.rtmpOptions.startProcessing = true;
          self.StartRTMPStreaming(self.rtmpDialog.rtmpOptions.sessionId);
          // setTimeout(() => {
          //   self.rtmpDialog.rtmpOptions.startProcessing = false;
          // }, 2000);
        } else if (action == 3) {
          self.rtmpDialog.rtmpOptions.stopProcessing = true;
          self.StopRTMPStreaming(self.rtmpDialog.sessionId);
          // setTimeout(() => {
          //   self.rtmpDialog.rtmpOptions.stopProcessing = false;
          // }, 2000);
        } else if (action == 4) {
          self.rtmpDialog.state = false;
          self.GoForInternalPlayer(self.rtmpDialog.sessionId);
        }
      }
    },

    initParticipantsListener(sessionId) {
      if (ZoomRTMPParticipantsListener) {
        ZoomRTMPParticipantsListener();
        ZoomRTMPParticipantsListener = null;
      }
      if (!ZoomRTMPParticipantsListener) {
        ZoomRTMPParticipantsListener = db
          .collection(self.eventcollection)
          .doc("SessionList")
          .collection("Sessions")
          .doc(sessionId)
          .collection("Participances")
          .onSnapshot((querySnapshot) => {
            var viewersCount = 0;
            querySnapshot.forEach((doc) => {
              if (doc.data().IsActive) {
                viewersCount++;
              }
            });
            self.rtmpDialog.rtmpOptions.viewersCount = viewersCount;
          });
      }
      db.collection(self.eventcollection)
        .doc("UserVideoActivity")
        .collection("Session")
        .doc(sessionId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let data = doc.data();
            self.rtmpDialog.rtmpOptions.chatEnabled = data.ChatEnabled
              ? data.ChatEnabled
              : false;
            self.rtmpDialog.rtmpOptions.qnaEnabled = data.QnAEnabled
              ? data.QnAEnabled
              : false;
            //self.rtmpDialog.rtmpOptions.attendeeEnabled = data.AttendeeEnabled
            //  ? data.AttendeeEnabled
            //  : false;
          }
        });
    },
    onStartSession(sessionId) {
      for (var i = 0; i < self.allSessions.length; i++) {
        if (self.allSessions[i].SessionId == sessionId) {
          var session = self.allSessions[i];
          if (session.SessionTypeDetails.TypeID == 1) {
            self.ShowBroadCastPg(
              session.SessionId,
              self.GlobalKeysData.IsVideoInNewTab,
              "video",
              self.eventId,
              self.GlobalKeysData.IsOpenInternalPlayer
            );
          } else if (session.SessionTypeDetails.TypeID == 2) {
            self.ShowBroadCastPg(
              session.SessionId,
              self.GlobalKeysData.IsVideoInNewTab,
              "video",
              self.eventId,
              self.GlobalKeysData.IsOpenInternalPlayer
            );
          } else if (session.SessionTypeDetails.TypeID == 3) {
            self.JoinLivePanel(
              self.GlobalKeysData.videoParamsEncryptURL,
              self.GlobalKeysData.BroadcastStartURL,
              self.GlobalKeysData.BroadcastViewURL,
              self.GlobalKeysData.IsBroadcastInNewTab,
              session.SessionId,
              self.GlobalKeysData.ChannelPrefix,
              self.GlobalKeysData.BroadcastID,
              self.GlobalKeysData.BroadcastCertificate,
              self.GlobalKeysData.BroadcastSpeakerApiUrl,
              self.GlobalKeysData.BroadcastAttendeeApiUrl,
              self.GlobalKeysData.BroadcastvalidityHours,
              self.userid,
              self.eventId,
              "startbroadcast",
              session.Name,
              session.broadcastUrlForSession,
              self.clientID,
              session.IamInThesession,
              self.GlobalKeysData.IsOpenInternalPlayer,
              session.StreamingClient,
              session.MappedHosts,
              session.MappedSpeakers,
              session.Zoom_Detail,
              session.IsZoomRTMP,
              session.ZoomRTMPMUX_detail,
              session.InPersonURL
            );
          } else if (session.SessionTypeDetails.TypeID == 4) {
            self.goToRTPage(session.SessionId);
          } else if (session.SessionTypeDetails.TypeID == 5) {
            self.GoForInternalPlayer(session.SessionId, session.InPersonURL);
          }
          break;
        }
      }
    },
    getSpeakerSettings() {
      self.ShowMeetingButton = false;
      self.ShowFilter = false;
      self.ShowSendMessageButton = false;
      self.ShowSearch = false;
      db.collection(self.eventcollection)
        .doc("Settings")
        .collection("Speaker")
        .doc("SpeakerSettings")
        .get()
        .then(function (doc) {
          if (doc.exists) {
            self.ShowMeetingButton =
              doc.data().ShowMeetingButton == undefined
                ? false
                : doc.data().ShowMeetingButton;
            self.ShowSendMessageButton =
              doc.data().ShowSendMessageButton == undefined
                ? false
                : doc.data().ShowSendMessageButton;
            // self.ShowFilter =
            //   doc.data().ShowFilter == undefined ? false : doc.data().ShowFilter;
            // self.ShowSearch =
            //   doc.data().ShowSearch == undefined ? false : doc.data().ShowSearch;
          }
        });
      console.log(self.ShowMeetingButton);
    },
    OpenRequestMeeting() {
      if (document.getElementById("dvImgeHldText").innerText == "") {
        var AttendeeImgPath = document.getElementById("imgModalSpeakers").src;

        if (AttendeeImgPath != null && AttendeeImgPath != "") {
          document.getElementById("ReqAttendeeImage").src = AttendeeImgPath;
        }

        $("#ReqAttendeeImage").show();
        document.getElementById("ReqdivImgHldText").innerText = "";
        $("#ReqdivImgHldText").hide();
      } else {
        var Initials = document.getElementById("dvImgeHldText").innerText;
        $("#ReqAttendeeImage").attr("src", "");
        $("#ReqAttendeeImage").hide();
        document.getElementById("ReqdivImgHldText").innerHTML =
          "<h4>" + Initials + "</h4>";
        $("#ReqdivImgHldText").show();
      }
      document.getElementById("ReqAttendeeEmail").innerText =
        document.getElementById("spnSpkEmail").innerText;

      document.getElementById("ReqAttendeePhone").innerText =
        document.getElementById("spnSpkPhone").innerText;

      document.getElementById("ReqAttendeeName").innerText =
        document.getElementById("modalName").innerText;
      document.getElementById("ReqAttendeeNameh4").innerText =
        document.getElementById("ReqAttendeeName").innerText;
      document.getElementById("ReqAttendeeTitle").innerText =
        document.getElementById("modalTtile").innerText;
      document.getElementById("ReqAttendeeCompany").innerText =
        document.getElementById("modalCompany").innerText;

      document.getElementById("ReqAttendeeEmail").innerText =
        document.getElementById("modalEmail").innerText;
      document.getElementById("ReqAttendeePhone").innerText =
        document.getElementById("modalPhone").innerText;
      document.getElementById("ReqAttendeeWebsite").innerText =
        document.getElementById("modalWebsite").innerText;

      var hdnattendeeId = $("#hdnattendeeId").val();

      var ComponentClass = Vue.extend(RequestMeeting);
      var instance = new ComponentClass({
        propsData: { attendeeId: hdnattendeeId },
      });
      instance.$mount();
    },
    prepareMySession() {
      self.mySessions = [];
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.eventId,
        },
        data: {
          AttendeeId: self.userid,
        },
      };
      //bus.$emit("toggleLoader", true);
      axios
        .post(APIs.MyAgenda, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          bus.$emit("toggleLoader", false);
          if (
            responseData &&
            responseData.data &&
            responseData.data.status == 0 &&
            responseData.data.sessions
          ) {
            responseData.data.sessions.map(function (item) {
              self.mySessions.push(item.SessionId);
            });
          }
          self.mySessionsLoaded = true;
        })
        .catch((error) => {
          bus.$emit("toggleLoader", false);
          console.log(error);
          self.mySessionsLoaded = true;
        });
    },
    loadAllSessions() {
      self.sessionTabList = [];
      self.speakerDetailsForPopup = [];
      db.collection(self.eventcollection)
        .doc("TrackList")
        .collection("Tracks")
        .get()
        .then((querySnapshotSpk) => {
          self.allTracks = [];
          querySnapshotSpk.forEach((doc) => {
            var trackId = doc.data().TrackId;
            var name = doc.data().Name;
            var colorCode = doc.data().ColorCode;
            self.allTracks.push({
              TrackId: trackId,
              Name: name,
              ColorCode: colorCode,
            });
          });
        });
      db.collection(self.eventcollection)
        .doc("SpeakerList")
        .collection("Speakers")
        .get()
        .then((querySnapshotSpk) => {
          self.allSpeakers = [];
          querySnapshotSpk.forEach((doc) => {
            var profile = doc.data().Profile;
            profile = profile == undefined ? "" : profile;
            var speakerId = doc.data().SpeakerId;
            var hideInList = doc.data().HideInList
              ? doc.data().HideInList
              : false;
            self.allSpeakers.push({
              SpeakerId: speakerId,
              Profile: profile,
              HideInList: hideInList,
            });
          });

          var listRef = db
            .collection(self.eventcollection) //"OA_UAT_C1591205467009E1591206650065")
            .doc("SessionList")
            .collection("Sessions");
          if (!self.isAdminComponent) {
            listRef = listRef.where("IsPublished", "==", true);
          }
          var dtt;

          listRef
            .orderBy("StartDate", "asc")
            .orderBy("EndDate", "asc")
            .get()
            .then((querySnapshot) => {
              var currentTime = parseInt(new Date().getTime() / 1000);
              querySnapshot.forEach((doc) => {
                let data = doc.data();
                var objSession = new Object();
                objSession.HideTime = false;
                objSession.HideTrack = false;
                objSession.HideStatus = false;
                objSession.HideTitle = false;
                objSession.HideShortDescription = false;
                objSession.HideSpeakers = false;
                objSession.HideJoinButton = false;
                objSession.ShowFeatureImage = false;
                objSession.ShowInSeparateRow = false;
                objSession.ShowBeforeConcurrentSessions = false;
                objSession.SessionTypeDetails = data.SessionTypeDetails;
                if (objSession.SessionTypeDetails.TypeID == 5) {
                  if (objSession.SessionTypeDetails.ShowFeatureImage) {
                    objSession.ShowFeatureImage =
                      objSession.SessionTypeDetails.ShowFeatureImage;
                  }
                  if (!objSession.SessionTypeDetails.FeatureImage) {
                    objSession.ShowFeatureImage = false;
                  }
                  if (objSession.SessionTypeDetails.ShowInSeparateRow) {
                    objSession.ShowInSeparateRow =
                      objSession.SessionTypeDetails.ShowInSeparateRow;
                  }
                  if (
                    objSession.SessionTypeDetails.ShowBeforeConcurrentSessions
                  ) {
                    objSession.ShowBeforeConcurrentSessions =
                      objSession.SessionTypeDetails.ShowBeforeConcurrentSessions;
                  }
                }

                let flag = true;
                if (self.trackId) {
                  flag = false;
                  if (data.Track && data.Track.TrackID) {
                    if (data.Track.TrackID == self.trackId) {
                      flag = true;
                    }
                  }
                }
                if (flag) {
                  var dateTabLabel;
                  if (data.StartDate != undefined) {
                    dtt = new Date(data.StartDate.seconds * 1000);
                    var dtYear = dtt.getFullYear();
                    var dtMonth = dtt.getMonth();
                    var dtDay = dtt.getDate();
                    dateTabLabel = dtt.toString().substring(0, 10);
                  } else {
                    dateTabLabel = "";
                  }
                  var sessionTab = self.sessionTabList.filter(function (value) {
                    return value.DateTabLabel == dateTabLabel;
                  });
                  if (sessionTab.length == 0) {
                    var tbObj = new Object();

                    tbObj.DateTabLabel = dateTabLabel; //display date tab format
                    tbObj.DateTabId =
                      "menu" +
                      tbObj.DateTabLabel.replace(" ", "").replace(" ", "");
                    tbObj.StartDate = new Date(dtYear, dtMonth, dtDay);

                    tbObj.StartTime = parseInt(
                      tbObj.StartDate.getTime() / 1000
                    );
                    tbObj.EndDate = new Date(dtYear, dtMonth, dtDay);
                    tbObj.EndDate.setDate(tbObj.EndDate.getDate() + 1);
                    tbObj.EndTime = parseInt(tbObj.EndDate.getTime() / 1000);
                    tbObj.CurrentClass = "";

                    self.sessionTabList.push(tbObj);

                    var sessionContentObj = new Object();
                    sessionContentObj.DateTabLabel = dateTabLabel;
                    sessionContentObj.DateTabId =
                      "menu" +
                      sessionContentObj.DateTabLabel.replace(" ", "").replace(
                        " ",
                        ""
                      );
                    sessionContentObj.CurrentClass = "";
                    sessionContentObj.SessionRowList = [];
                    self.sessionContentList.push(sessionContentObj);
                  }
                  var sessionContents = self.sessionContentList.filter(
                    function (value) {
                      return value.DateTabLabel == dateTabLabel;
                    }
                  );
                  if (sessionContents.length != 0) {
                    var sessionTabIndex = self.sessionContentList.indexOf(
                      sessionContents[0]
                    );
                    var filteredRows = self.sessionContentList[
                      sessionTabIndex
                    ].SessionRowList.filter(function (value) {
                      return (
                        value.StartTime == data.StartDate.seconds &&
                        value.ShowInSeparateRow == objSession.ShowInSeparateRow
                      );
                    });
                    if (filteredRows.length == 0) {
                      var objRow = new Object();
                      objRow.ShowInSeparateRow = objSession.ShowInSeparateRow;
                      objRow.StartTime = data.StartDate.seconds;
                      objRow.EndTime = data.EndDate.seconds;
                      objRow.SessionCollection = [];
                      self.sessionContentList[
                        sessionTabIndex
                      ].SessionRowList.push(objRow);
                    }

                    filteredRows = self.sessionContentList[
                      sessionTabIndex
                    ].SessionRowList.filter(function (value) {
                      return (
                        value.StartTime == data.StartDate.seconds &&
                        value.ShowInSeparateRow == objSession.ShowInSeparateRow
                      );
                    });

                    //-----------------------------------------------------------------------------------

                    if (filteredRows.length != 0) {
                      // var currentRows = filteredRows[0];

                      var sessionIndex = self.sessionContentList[
                        sessionTabIndex
                      ].SessionRowList.indexOf(filteredRows[0]);

                      objSession.SessionId =
                        data.SessionId != undefined ? data.SessionId : "0";
                      objSession.Name = data.Name != undefined ? data.Name : "";
                      objSession.DescriptionShort = data.DescriptionShort
                        ? data.DescriptionShort
                        : "";
                      objSession.Description = data.Description
                        ? data.Description
                        : "";
                      objSession.IsPublished = data.IsPublished;
                      objSession.StartDate = data.StartDate;
                      objSession.EndDate = data.EndDate;
                      objSession.StartTime = data.StartDate.seconds;
                      objSession.EndTime = data.EndDate.seconds;

                      objSession.IsStatusChanging = false;
                      objSession.IsDeleting = false;

                      objSession.IsHost = false;
                      objSession.IsSpeaker = false;
                      objSession.HasBackStageAccess = false;

                      objSession.MappedSpeakers = data.MappedSpeakers
                        ? data.MappedSpeakers
                        : [];
                      objSession.MappedHosts = data.MappedHosts
                        ? data.MappedHosts
                        : [];
                      objSession.MappedCoHost = data.MappedCoHost
                        ? [data.MappedCoHost]
                        : [];

                      objSession.MappedSpeakers.forEach(function (item) {
                        if (item.AttendeeId == self.userid) {
                          objSession.IsSpeaker = true;
                        }
                        item.Name = item.Name ? item.Name : "";
                        item.NameInitial = common.getInitials(item.Name);
                        item.Company = item.Company ? item.Company : "";
                        item.Designation = item.Designation
                          ? item.Designation
                          : "";
                        item.ProfilePictureURL = item.ProfilePictureURL
                          ? item.ProfilePictureURL
                          : "";
                        var spkrs = self.allSpeakers.filter(function (spkr) {
                          return item.AttendeeId == spkr.SpeakerId;
                        });
                        if (spkrs.length > 0) {
                          item.Profile = spkrs[0].Profile;
                          item.HideInList = spkrs[0].HideInList;
                        }
                      });
                      objSession.MappedHosts.forEach(function (item) {
                        if (item.AttendeeId == self.userid) {
                          objSession.IsHost = true;
                        }
                        item.Name = item.Name ? item.Name : "";
                        item.NameInitial = common.getInitials(item.Name);
                        item.Company = item.Company ? item.Company : "";
                        item.Designation = item.Designation
                          ? item.Designation
                          : "";
                        item.ProfilePictureURL = item.ProfilePictureURL
                          ? item.ProfilePictureURL
                          : "";

                        var spkrs = self.allSpeakers.filter(function (spkr) {
                          return item.AttendeeId == spkr.SpeakerId;
                        });
                        if (spkrs.length > 0) {
                          item.Profile = spkrs[0].Profile;
                          item.HideInList = spkrs[0].HideInList;
                        }
                      });
                      objSession.MappedCoHost.forEach(function (item) {
                        if (item.AttendeeId == self.userid) {
                          objSession.IsHost = true;
                        }
                        item.Name = item.Name ? item.Name : "";
                        item.NameInitial = common.getInitials(item.Name);
                        item.Company = item.Company ? item.Company : "";
                        item.Designation = item.Designation
                          ? item.Designation
                          : "";
                        item.ProfilePictureURL = item.ProfilePictureURL
                          ? item.ProfilePictureURL
                          : "";
                        var spkrs = self.allSpeakers.filter(function (spkr) {
                          return item.AttendeeId == spkr.SpeakerId;
                        });
                        if (spkrs.length > 0) {
                          item.Profile = spkrs[0].Profile;
                          item.HideInList = spkrs[0].HideInList;
                        }
                      });

                      objSession.MappedSpeakers.sort(function (a, b) {
                        let aName = a.Name.trim().toLowerCase();
                        let bName = b.Name.trim().toLowerCase();
                        if (aName < bName) {
                          return -1;
                        }
                        if (aName > bName) {
                          return 1;
                        }
                        return 0;
                      });
                      objSession.MappedHosts.sort(function (a, b) {
                        let aName = a.Name.trim().toLowerCase();
                        let bName = b.Name.trim().toLowerCase();
                        if (aName < bName) {
                          return -1;
                        }
                        if (aName > bName) {
                          return 1;
                        }
                        return 0;
                      });

                      objSession.StreamingClient = data.StreamingClient;
                      objSession.Zoom_Detail = data.Zoom_Detail;
                      objSession.IsRTMP = data.IsRTMP ? data.IsRTMP : false;
                      objSession.IsZoomRTMP = data.IsZoomRTMP
                        ? data.IsZoomRTMP
                        : false;
                      objSession.MeetingStarted = data.MeetingStarted
                        ? data.MeetingStarted
                        : false;
                      objSession.ZoomRTMPMUX_detail = data.ZoomRTMPMUX_detail;
                      objSession.ZoomRTMPEnable_Status =
                        data.ZoomRTMPEnable_Status;
                      objSession.RTMPStarted = data.RTMPStarted
                        ? data.RTMPStarted
                        : false;
                      objSession.Resources = data.Resources;
                      objSession.SessionTypeDetails = data.SessionTypeDetails;
                      if (
                        objSession.SessionTypeDetails
                          .ConvertToOnDemandVideoOnSessionEnd == undefined
                      ) {
                        objSession.SessionTypeDetails.ConvertToOnDemandVideoOnSessionEnd = false;
                      }

                      objSession.InPersonLabel = "In-Person";
                      objSession.InPersonIcon =
                        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2Fin-person.svg?alt=media";
                      objSession.InPersonURL = "";
                      if ([5, 6].includes(data.SessionTypeDetails.TypeID)) {
                        if (data.SessionTypeDetails.InPersonLabel) {
                          objSession.InPersonLabel =
                            data.SessionTypeDetails.InPersonLabel;
                        }
                        if (data.SessionTypeDetails.InPersonIcon) {
                          objSession.InPersonIcon =
                            data.SessionTypeDetails.InPersonIcon;
                        }
                        if (data.SessionTypeDetails.InPersonURL) {
                          objSession.InPersonURL =
                            data.SessionTypeDetails.InPersonURL;
                        }
                        if (!objSession.InPersonURL) {
                          if (
                            objSession.IsHost &&
                            data.SessionTypeDetails.HostURL
                          ) {
                            objSession.InPersonURL =
                              data.SessionTypeDetails.HostURL;
                          } else if (
                            objSession.IsSpeaker &&
                            data.SessionTypeDetails.SpeakerURL
                          ) {
                            objSession.InPersonURL =
                              data.SessionTypeDetails.SpeakerURL;
                          } else if (data.SessionTypeDetails.AttendeeURL) {
                            objSession.InPersonURL =
                              data.SessionTypeDetails.AttendeeURL;
                          }
                        }
                        if (data.SessionTypeDetails.HideTime) {
                          objSession.HideTime =
                            data.SessionTypeDetails.HideTime;
                        }
                        if (data.SessionTypeDetails.HideTrack) {
                          objSession.HideTrack =
                            data.SessionTypeDetails.HideTrack;
                        }
                        if (data.SessionTypeDetails.HideStatus) {
                          objSession.HideStatus =
                            data.SessionTypeDetails.HideStatus;
                        }
                        if (data.SessionTypeDetails.HideTitle) {
                          objSession.HideTitle =
                            data.SessionTypeDetails.HideTitle;
                        }
                        if (data.SessionTypeDetails.HideShortDescription) {
                          objSession.HideShortDescription =
                            data.SessionTypeDetails.HideShortDescription;
                        }
                        if (data.SessionTypeDetails.HideSpeakers) {
                          objSession.HideSpeakers =
                            data.SessionTypeDetails.HideSpeakers;
                        }
                        if (data.SessionTypeDetails.HideJoinButton) {
                          objSession.HideJoinButton =
                            data.SessionTypeDetails.HideJoinButton;
                        }
                        if (data.SessionTypeDetails.ShowFeatureImage) {
                          objSession.ShowFeatureImage =
                            data.SessionTypeDetails.ShowFeatureImage;
                        }
                        if (!data.SessionTypeDetails.FeatureImage) {
                          objSession.ShowFeatureImage = false;
                        }
                        if (data.SessionTypeDetails.ShowInSeparateRow) {
                          objSession.ShowInSeparateRow =
                            data.SessionTypeDetails.ShowInSeparateRow;
                        }
                        if (
                          data.SessionTypeDetails.ShowBeforeConcurrentSessions
                        ) {
                          objSession.ShowBeforeConcurrentSessions =
                            data.SessionTypeDetails.ShowBeforeConcurrentSessions;
                        }
                      }
                      objSession.Track = data.Track;
                      if (!objSession.Track) {
                        objSession.Track = { TrackID: "", TrackName: "" };
                      }
                      for (var i = 0; i < objSession.MappedHosts.length; i++) {
                        if (!objSession.MappedHosts[i].ProfilePictureURL) {
                          objSession.MappedHosts[i].ProfilePictureURL = "";
                        }
                        objSession.MappedHosts[i].NameInitial =
                          common.getInitials(objSession.MappedHosts[i].Name);
                      }
                      for (
                        var j = 0;
                        j < objSession.MappedSpeakers.length;
                        j++
                      ) {
                        if (!objSession.MappedSpeakers[j].ProfilePictureURL) {
                          objSession.MappedSpeakers[j].ProfilePictureURL = "";
                        }
                        objSession.MappedSpeakers[j].NameInitial =
                          common.getInitials(objSession.MappedSpeakers[j].Name);
                        objSession.MappedSpeakers[j].Company = objSession
                          .MappedSpeakers[j].Company
                          ? objSession.MappedSpeakers[j].Company
                          : "";
                        objSession.MappedSpeakers[j].Designation = objSession
                          .MappedSpeakers[j].Designation
                          ? objSession.MappedSpeakers[j].Designation
                          : "";
                      }
                      objSession.StartTimeLabel = self.getFormattedDateTime(
                        data.StartDate.seconds
                      );
                      objSession.EndTimeLabel = self.getFormattedDateTime(
                        data.EndDate.seconds
                      );
                      objSession.DateTabLabel = dateTabLabel;
                      // objSession.StartDateTimeLabel = self.getFormattedDateTime(
                      //   data.StartDate.seconds
                      // );
                      // objSession.EndDateTimeLabel = self.getFormattedDateTime(
                      //   data.EndDate.seconds
                      // );
                      objSession.IsLive = false;
                      objSession.IsUpcoming = false;
                      objSession.ShowOnDemandVideo = false;
                      objSession.Location =
                        data.Location && data.Location.LocationName
                          ? data.Location.LocationName
                          : "";

                      objSession.LinkClass =
                        "upcoming-status new-btn-design-disabled";
                      objSession.StatusDisplayText =
                        self.$t("livestage.upcoming");
                      objSession.StatusClass = "upcoming-session";
                      if (currentTime < objSession.StartTime) {
                        if (
                          (objSession.IsHost || objSession.IsSpeaker) &&
                          objSession.SessionTypeDetails.TypeID ==
                            self.GlobalKeysData.LivePanelTypeID
                        ) {
                          objSession.IsLive = true;
                          objSession.LinkClass = "ongoing-status";
                          objSession.HasBackStageAccess = true;
                        } else {
                          objSession.LinkClass =
                            "upcoming-status new-btn-design-disabled";
                        }
                        objSession.StatusDisplayText =
                          self.$t("livestage.upcoming");
                        objSession.StatusClass = "upcoming-session";
                        objSession.IsUpcoming = true;
                      } else if (
                        currentTime > objSession.StartTime &&
                        currentTime < objSession.EndTime
                      ) {
                        if (
                          objSession.IsHost ||
                          objSession.IsSpeaker ||
                          objSession.SessionTypeDetails.TypeID != 3
                        ) {
                          objSession.IsLive = true;
                          objSession.StatusDisplayText =
                            self.$t("livestage.live");
                          objSession.StatusClass = "active-session";
                          objSession.LinkClass = "ongoing-status";
                        } else {
                          if (objSession.IsZoomRTMP || objSession.IsRTMP) {
                            if (objSession.RTMPStarted) {
                              objSession.IsLive = true;
                              objSession.LinkClass = "ongoing-status";
                            }
                          } else {
                            objSession.IsLive = true;
                            objSession.LinkClass = "ongoing-status";
                          }
                          objSession.StatusDisplayText =
                            self.$t("livestage.live");
                          objSession.StatusClass = "active-session";
                        }
                      } else if (currentTime > objSession.EndTime) {
                        if (
                          objSession.SessionTypeDetails.TypeID ==
                          self.GlobalKeysData.OnDemandTypeID
                        ) {
                          objSession.IsLive = true;
                          objSession.StatusDisplayText = self.$t(
                            "livestage.sessionended"
                          );
                          objSession.StatusClass = "finish-session";
                          objSession.LinkClass = "ongoing-status";
                        } else {
                          objSession.StatusDisplayText = self.$t(
                            "livestage.sessionended"
                          );
                          objSession.StatusClass = "finish-session";
                          objSession.LinkClass =
                            "finish-status new-btn-design-disabled";
                        }
                      }
                      if (
                        objSession.SessionTypeDetails.TypeID ==
                        self.GlobalKeysData.OnDemandTypeID
                      ) {
                        objSession.LinkClass += " session-link";
                      }

                      self.sessionContentList[sessionTabIndex].SessionRowList[
                        sessionIndex
                      ].SessionCollection.push(objSession);
                      let sessions = self.allSessions.filter((item) => {
                        return item.SessionId == objSession.SessionId;
                      });
                      if (sessions.length == 0) {
                        self.allSessions.push(objSession);
                      }
                    }
                  }
                }
              });

              var tabSelected = false;
              var tIndx = 0;
              var todaysTab = self.sessionTabList.filter(function (tab) {
                return (
                  currentTime * 1000 >= tab.StartTime &&
                  currentTime < tab.EndTime
                );
              });
              if (todaysTab.length > 0) {
                for (tIndx = 0; tIndx < self.sessionTabList.length; tIndx++) {
                  if (!tabSelected) {
                    if (
                      currentTime * 1000 >=
                        self.sessionTabList[tIndx].StartTime &&
                      currentTime * 1000 < self.sessionTabList[tIndx].EndTime
                    ) {
                      self.selectedDateValue =
                        self.sessionTabList[tIndx].DateTabId;
                      self.sessionTabList[tIndx].CurrentClass = "active";
                      self.sessionContentList[tIndx].CurrentClass = "active";
                      tabSelected = true;
                      break;
                    }
                  }
                }
              }

              if (!tabSelected) {
                var upCommingTab = self.sessionTabList.filter(function (tab) {
                  return currentTime * 1000 < tab.StartTime;
                });
                if (upCommingTab.length > 0) {
                  for (tIndx = 0; tIndx < self.sessionTabList.length; tIndx++) {
                    if (!tabSelected) {
                      if (
                        currentTime * 1000 <
                        self.sessionTabList[tIndx].StartTime
                      ) {
                        self.selectedDateValue =
                          self.sessionTabList[tIndx].DateTabId;
                        self.sessionTabList[tIndx].CurrentClass = "active";
                        self.sessionContentList[tIndx].CurrentClass = "active";
                        tabSelected = true;
                        break;
                      }
                    }
                  }
                }
              }

              if (!tabSelected) {
                var finishedTab = self.sessionTabList.filter(function (tab) {
                  return currentTime * 1000 > tab.StartTime;
                });
                if (finishedTab.length > 0) {
                  for (
                    tIndx = self.sessionTabList.length - 1;
                    tIndx >= 0;
                    tIndx--
                  ) {
                    if (!tabSelected) {
                      if (
                        currentTime * 1000 >
                        self.sessionTabList[tIndx].StartTime
                      ) {
                        self.selectedDateValue =
                          self.sessionTabList[tIndx].DateTabId;
                        self.sessionTabList[tIndx].CurrentClass = "active";
                        self.sessionContentList[tIndx].CurrentClass = "active";
                        tabSelected = true;
                        break;
                      }
                    }
                  }
                }
              }
              //-------------------------------------------------------
              for (
                var tIndex = 0;
                tIndex < self.sessionContentList.length;
                tIndex++
              ) {
                for (
                  var rIndex = 0;
                  rIndex <
                  self.sessionContentList[tIndex].SessionRowList.length;
                  rIndex++
                ) {
                  var rowSessCnt =
                    self.sessionContentList[tIndex].SessionRowList[rIndex]
                      .SessionCollection.length;

                  self.sessionContentList[tIndex].SessionRowList[
                    rIndex
                  ].RowSessionCount = rowSessCnt;

                  self.sessionContentList[tIndex].SessionRowList[
                    rIndex
                  ].StartTimeLabel =
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].SessionCollection[0].StartTimeLabel;
                  self.sessionContentList[tIndex].SessionRowList[
                    rIndex
                  ].EndTimeLabel =
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].SessionCollection[0].EndTimeLabel;

                  if (rowSessCnt == 1) {
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].SessionClass = "one-session";

                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].TrackClass = "one-track";
                  } else if (rowSessCnt == 2) {
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].SessionClass = "two-session";
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].TrackClass = "two-track";
                  } else if (rowSessCnt == 3) {
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].SessionClass = "three-session";
                    self.sessionContentList[tIndex].SessionRowList[
                      rIndex
                    ].TrackClass = "three-track";
                  }
                }
              }
              self.sessionsLoaded = true;
              //if (
              //  self.AgendaFilterOption >= 0 &&
              //  self.selectedAgendaType == -1
              //) {
              //  self.selectedAgendaType = 0;
              //  self.setupCurrentTabs();
              //}
              //console.log(self.sessionTabList);
              //self.selectedTabSessions = self.sessionContentList.filter(
              //  function () {
              //    return true;
              //  }
              //);
              console.log(self.sessionContentList);

              setTimeout(() => {
                $('[data-toggle="tooltip"]').tooltip();
              }, 1000);
            })
            .catch((error) => {
              alert(error);
              console.trace(error);
            });
        })
        .catch(function (error) {
          console.error("Error : ", error);
        });
      $("#dvMainTabContent div:first").addClass("active");
    },
    updateSessionStatus() {
      var currentTime = parseInt(new Date().getTime() / 1000);
      var currentTimeCustom =
        parseInt(new Date().getTime() / 1000) +
        self.CustomURLSessionLiveBeforeMinutes * 60;
      self.selectedTabSessions.forEach((doc) => {
        doc.SessionRowList.forEach((sessionRow) => {
          sessionRow.SessionCollection.forEach((objSession) => {
            objSession.HasBackStageAccess = false;
            var uSpkrs = objSession.MappedSpeakers.filter(function (value) {
              return value.AttendeeId == self.userid;
            });
            if (currentTime < objSession.StartTime) {
              if (
                (uSpkrs.length > 0 &&
                  objSession.SessionTypeDetails.TypeID ==
                    self.GlobalKeysData.LivePanelTypeID) ||
                (objSession.SessionTypeDetails.TypeID ==
                  self.GlobalKeysData.CustomUrlTypeID &&
                  currentTimeCustom > objSession.StartTime &&
                  currentTime < objSession.EndTime)
              ) {
                objSession.IsLive = true;
                objSession.LinkClass = "ongoing-status";
                objSession.HasBackStageAccess = true;
              } else {
                objSession.LinkClass =
                  "upcoming-status new-btn-design-disabled";
              }
              objSession.StatusDisplayText = self.$t("livestage.upcoming");
              objSession.StatusClass = "upcoming-session";
            } else if (
              currentTime > objSession.StartTime &&
              currentTime < objSession.EndTime
            ) {
              if (
                self.IsZoomRTMPOptionsEnabled &&
                objSession.IsZoomRTMP &&
                !objSession.ZoomRTMPListener
              ) {
                self.ZoomRTMPStatusListener(objSession);
              }
              if (
                self.IsRTMPEnabled &&
                objSession.IsRTMP &&
                !objSession.RTMPListener
              ) {
                self.RTMPStatusListener(objSession);
              }
              if (
                objSession.IsHost ||
                objSession.IsSpeaker ||
                objSession.SessionTypeDetails.TypeID != 3
              ) {
                objSession.IsLive = true;
                objSession.StatusDisplayText = self.$t("livestage.live");
                objSession.StatusClass = "active-session";
                objSession.LinkClass = "ongoing-status";
              } else {
                if (objSession.IsZoomRTMP || objSession.IsRTMP) {
                  if (objSession.RTMPStarted) {
                    objSession.IsLive = true;
                    objSession.LinkClass = "ongoing-status";
                  } else {
                    objSession.IsLive = false;
                    objSession.LinkClass =
                      "upcoming-status new-btn-design-disabled";
                  }
                } else {
                  objSession.IsLive = true;
                  objSession.LinkClass = "ongoing-status";
                }
                objSession.StatusClass = "active-session";
                objSession.StatusDisplayText = self.$t("livestage.live");
              }
            } else if (currentTime > objSession.EndTime) {
              if (
                objSession.SessionTypeDetails.TypeID ==
                  self.GlobalKeysData.LivePanelTypeID &&
                objSession.IsLive &&
                objSession.IsZoomRTMP
              ) {
                if (objSession.ZoomRTMPListener) {
                  objSession.ZoomRTMPListener();
                  objSession.ZoomRTMPListener = null;
                }
                if (objSession.RTMPListener) {
                  objSession.RTMPListener();
                  objSession.RTMPListener = null;
                }
              }
              if (
                objSession.SessionTypeDetails.TypeID ==
                self.GlobalKeysData.OnDemandTypeID
              ) {
                objSession.IsLive = true;
                objSession.StatusDisplayText = self.$t(
                  "livestage.sessionended"
                );
                objSession.StatusClass = "finish-session";
                objSession.LinkClass = "ongoing-status";
              } else {
                if (
                  objSession.SessionTypeDetails
                    .ConvertToOnDemandVideoOnSessionEnd &&
                  objSession.SessionTypeDetails.TypeID ==
                    self.GlobalKeysData.LivePanelTypeID &&
                  objSession.LinkClass == "ongoing-status"
                ) {
                  let meetingId = "";
                  if (objSession.Zoom_Detail && objSession.Zoom_Detail.id) {
                    meetingId = objSession.Zoom_Detail.id;
                  }
                  self.tryConvertLivePanelToOnDemandVideo(
                    objSession.SessionId,
                    meetingId
                  );
                }
                objSession.IsLive = false;
                objSession.StatusDisplayText = self.$t(
                  "livestage.sessionended"
                );
                objSession.StatusClass = "finish-session";
                objSession.LinkClass = "finish-status new-btn-design-disabled";
              }
            }
            if (
              objSession.SessionTypeDetails.TypeID ==
              self.GlobalKeysData.OnDemandTypeID
            ) {
              objSession.LinkClass += " session-link";
            }
          });
        });
      });
      self.selectedTabSessions = self.selectedTabSessions.filter(function () {
        return true;
      });
      self.sessionListForPopup.forEach((objSession) => {
        objSession.HasBackStageAccess = false;
        if (currentTime < objSession.StartTime) {
          if (
            (objSession.IsSpeaker || objSession.IsHost) &&
            objSession.SessionTypeDetails.TypeID ==
              self.GlobalKeysData.LivePanelTypeID
          ) {
            objSession.IsLive = true;
            objSession.LinkClass = "ongoing-status";
            objSession.HasBackStageAccess = true;
          } else {
            objSession.LinkClass = "upcoming-status new-btn-design-disabled";
          }
          objSession.StatusDisplayText = self.$t("livestage.upcoming");
          objSession.StatusClass = "upcoming-session";
        } else if (
          currentTime > objSession.StartTime &&
          currentTime < objSession.EndTime
        ) {
          if (objSession.IsHost || objSession.IsSpeaker) {
            objSession.IsLive = true;
            objSession.StatusDisplayText = self.$t("livestage.live");
            objSession.StatusClass = "active-session";
            objSession.LinkClass = "ongoing-status";
          } else {
            if (objSession.RTMPStarted) {
              objSession.IsLive = true;
              objSession.LinkClass = "ongoing-status";
            } else {
              objSession.IsLive = false;
              objSession.LinkClass = "upcoming-status new-btn-design-disabled";
            }
            objSession.StatusClass = "active-session";
            objSession.StatusDisplayText = self.$t("livestage.live");
          }
          // objSession.IsLive = true;
          // objSession.StatusClass = "active-session";
          // objSession.LinkClass = "ongoing-status";
          // objSession.StatusDisplayText = self.$t("livestage.live");
        } else if (currentTime > objSession.EndTime) {
          if (
            objSession.SessionTypeDetails.TypeID ==
            self.GlobalKeysData.OnDemandTypeID
          ) {
            objSession.IsLive = true;
            objSession.StatusDisplayText = self.$t("livestage.sessionended");
            objSession.StatusClass = "finish-session";
            objSession.LinkClass = "ongoing-status";
          } else {
            objSession.StatusDisplayText = self.$t("livestage.sessionended");
            objSession.StatusClass = "finish-session";
            objSession.LinkClass = "finish-status new-btn-design-disabled";
          }
        }
        if (
          objSession.SessionTypeDetails.TypeID ==
          self.GlobalKeysData.OnDemandTypeID
        ) {
          objSession.LinkClass += " session-link";
        }
      });
      self.sessionListForPopup = self.sessionListForPopup.filter(function () {
        return true;
      });
    },
    ZoomRTMPStatusListener(objSession) {
      if (!objSession.ZoomRTMPListener) {
        objSession.ZoomRTMPListener = db
          .collection(self.eventcollection)
          .doc("SessionList")
          .collection("Sessions")
          .doc(objSession.SessionId)
          .onSnapshot((doc) => {
            var data = doc.data();
            objSession.RTMPStarted = data.RTMPStarted
              ? data.RTMPStarted
              : false;
            objSession.MeetingStarted = data.MeetingStarted
              ? data.MeetingStarted
              : false;
            //alert(objSession.RTMPStarted);
            //if (!objSession.RTMPStarted) {
            //  objSession.IsLive = false;

            //  objSession.LinkClass = "upcoming-status new-btn-design-disabled";
            //  objSession.StatusDisplayText = self.$t("livestage.upcoming");
            //  objSession.StatusClass = "upcoming-session";
            //}
            if (objSession.SessionId == self.rtmpDialog.sessionId) {
              self.rtmpDialog.session = objSession;
              self.rtmpDialog.lastUpdateTimeStamp = new Date().getTime();
            }
          });
      }
    },
    RTMPStatusListener(objSession) {
      if (!objSession.RTMPListener) {
        let firstLoad = true;
        objSession.RTMPListener = db
          .collection(self.eventcollection)
          .doc("SessionList")
          .collection("Sessions")
          .doc(objSession.SessionId)
          .onSnapshot((doc) => {
            var data = doc.data();
            if (!firstLoad) {
              objSession.RTMPStarted = data.RTMPStarted
                ? data.RTMPStarted
                : false;
            }
            firstLoad = false;
          });
      }
    },
    tryConvertLivePanelToOnDemandVideo(sessionId, meetingId) {
      let channelName =
        "OAUAT_" + self.eventId.substring("1") + "_" + sessionId;
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.eventId,
        },
        data: {
          recEventId: self.eventId.substring("1"),
          sessionId: sessionId,
          //channelId: channelName,
          channelId: "",
          meetingId: "",
        },
      };
      if (meetingId) {
        requestData.data.meetingId = meetingId;
      } else {
        requestData.data.channelId = channelName;
      }
      axios
        .post(APIs.LivePanelToOnDemandVideo, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          console.log(responseData);
          if (responseData && responseData.data.status == 0) {
            let objSessions = self.allSessions.filter(function (item) {
              return item.SessionId == sessionId;
            });
            if (objSessions.length > 0) {
              objSessions[0].SessionTypeDetails.TypeID = 1;
              objSessions[0].SessionTypeDetails.TypeName = "On Demand";
              //objSessions[0].SessionTypeDetails.VideoURL =
              //  responseData.data.msg;
              objSessions[0].IsLive = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setFirebaseAppsettings: function () {
      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");
      docRef.get().then(function (doc) {
        if (doc.exists) {
          self.GlobalKeysData.BroadcastID = doc.data().AppIDRTC;
          self.GlobalKeysData.BroadcastCertificate = doc.data().CertificateRTC;
          self.GlobalKeysData.BroadcastSpeakerApiUrl =
            doc.data().SpeakerTokenURL;
          self.GlobalKeysData.BroadcastAttendeeApiUrl =
            doc.data().AttendeeTokenURL;
          self.GlobalKeysData.BroadcastStartURL = doc.data().BroadcastBaseURL;
          self.GlobalKeysData.BroadcastViewURL = doc.data().AudienceBaseURL;
          self.GlobalKeysData.BroadcastvalidityHours =
            doc.data().TokenValidityHours;
          self.GlobalKeysData.ChannelPrefix = doc.data().ChannelPrefix;
          self.GlobalKeysData.videoParamsEncryptURL = doc.data().EncryptionURL;
        }
      });
    },
    CloseModal: function () {
      $("#modalOpenBroadcast").modal("hide");
      $("#iframeBroadcast").attr("src", "");
      $("#modalOpenBroadcast").removeClass("minimize");
      $("#modalOpenBroadcast").removeClass("maximize-window");
      $(".modal-backdrop").hide();
    },
    retryJoinInZoomPopup() {
      $("#RetryJoinInZoom").modal(
        {
          backdrop: "static",
        },
        "show"
      );
    },
    cancelRetryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
    },
    retryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
      if (self.tempSession) {
        self.JoinLivePanel(
          self.tempSession.videoParamsEncryptURL,
          self.tempSession.BroadcastStartURL,
          self.tempSession.BroadcastViewURL,
          self.tempSession.IsBroadcastInNewTab,
          self.tempSession.sessionID,
          self.tempSession.ChannelPrefix,
          self.tempSession.BroadcastID,
          self.tempSession.BroadcastCertificate,
          self.tempSession.BroadcastSpeakerApiUrl,
          self.tempSession.BroadcastAttendeeApiUrl,
          self.tempSession.BroadcastvalidityHours,
          self.tempSession.UserID,
          self.tempSession.eventID,
          self.tempSession.BroadCastType,
          self.tempSession.SessionTitle,
          self.tempSession.BroadcastURL,
          self.tempSession.clientID,
          self.tempSession.IamInThesession,
          self.tempSession.IsOpenInternalPlayer,
          self.tempSession.StreamingClient,
          self.tempSession.MappedHost,
          self.tempSession.MappedSpeakers,
          self.tempSession.ZoomDetails,
          self.tempSession.IsZoomRTMP,
          self.tempSession.ZoomRTMPMUX_detail,
          self.tempSession.externalLink
        );
      }
    },
    JoinLivePanel: function (
      videoParamsEncryptURL,
      BroadcastStartURL,
      BroadcastViewURL,
      IsBroadcastInNewTab,
      sessionID,
      ChannelPrefix,
      BroadcastID,
      BroadcastCertificate,
      BroadcastSpeakerApiUrl,
      BroadcastAttendeeApiUrl,
      BroadcastvalidityHours,
      UserID,
      eventID,
      BroadCastType,
      SessionTitle,
      BroadcastURL,
      clientID,
      IamInThesession,
      IsOpenInternalPlayer,
      StreamingClient,
      MappedHost,
      MappedSpeakers,
      ZoomDetails,
      IsZoomRTMP,
      ZoomRTMPMUX_detail,
      externalLink
    ) {
      if (!self.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      if (StreamingClient == "Zoom") {
        self.tempSession = {
          videoParamsEncryptURL: videoParamsEncryptURL,
          BroadcastStartURL: BroadcastStartURL,
          BroadcastViewURL: BroadcastViewURL,
          IsBroadcastInNewTab: IsBroadcastInNewTab,
          sessionID: sessionID,
          ChannelPrefix: ChannelPrefix,
          BroadcastID: BroadcastID,
          BroadcastCertificate: BroadcastCertificate,
          BroadcastSpeakerApiUrl: BroadcastSpeakerApiUrl,
          BroadcastAttendeeApiUrl: BroadcastAttendeeApiUrl,
          BroadcastvalidityHours: BroadcastvalidityHours,
          UserID: UserID,
          eventID: eventID,
          BroadCastType: BroadCastType,
          SessionTitle: SessionTitle,
          BroadcastURL: BroadcastURL,
          clientID: clientID,
          IamInThesession: IamInThesession,
          IsOpenInternalPlayer: IsOpenInternalPlayer,
          StreamingClient: StreamingClient,
          MappedHost: MappedHost,
          MappedSpeakers: MappedSpeakers,
          ZoomDetails: ZoomDetails,
          IsZoomRTMP: IsZoomRTMP,
          ZoomRTMPMUX_detail: ZoomRTMPMUX_detail,
          externalLink: externalLink,
        };
        var hostList = [];
        var speakerList = [];

        MappedHost.filter(function (value) {
          hostList.push(value.AttendeeId);
        });

        MappedSpeakers.filter(function (value) {
          speakerList.push(value.AttendeeId);
        });

        if (hostList.indexOf(self.userid) > -1) {
          if (IsZoomRTMP) {
            self.rtmpActions(0, sessionID);
            //  self.GoForInternalPlayer(sessionID, externalLink);
          } else {
            window.open(ZoomDetails.start_url, "_blank");
            self.postLeaderboardAction("SNVW");
          }
        } else if (speakerList.indexOf(self.userid) > -1) {
          if (IsZoomRTMP) {
            self.rtmpActions(0, sessionID);
          } else {
            bus.$emit("toggleLoader", true);

            let headers = {
              Authorization: "Bearer " + self.getSessionToken(),
              "content-type": "application/json",
            };
            let requestData = {
              email: self.email,
              name: self.name,
              first_name: self.firstName,
              last_name: self.lastName,
              webinarid: ZoomDetails.id,
              meeting_type: "webinar",
              make_speaker: true,
              //address: "",
              //phone: self.phone,
              //industry: "",
              //org: self.company,
              //job_title: self.title,
            };
            //bus.$emit("toggleLoader", true);
            axios
              .post(APIs.AddAttendeesToZoom, requestData, {
                headers: headers,
              })
              .then((response) => {
                if (
                  response &&
                  response.data &&
                  response.data.status == 0 &&
                  response.data.data.id &&
                  response.data.data.join_url &&
                  response.data.data.join_url != ""
                ) {
                  bus.$emit("toggleLoader", false);
                  window.open(response.data.data.join_url, "_blank");
                  self.postLeaderboardAction("SNVW");

                  //let headers = {
                  //  "content-type": "application/json",
                  //};
                  //let requestData = {
                  //  email: self.email,
                  //  name: self.firstName + " " + self.lastName,
                  //  webinarid: ZoomDetails.id,
                  //};
                  //axios
                  //  .post(APIs.AddSpeakersToZoom, requestData, {
                  //    headers: headers,
                  //  })
                  //  .then((response1) => {
                  //    bus.$emit("toggleLoader", false);
                  //    if (response1.data && response1.data.id) {
                  //      window.open(response.data.join_url, "_blank");
                  //      self.postLeaderboardAction("SNVW");
                  //    } else {
                  //      self.retryJoinInZoomPopup();
                  //    }
                  //  })
                  //  .catch((error) => {
                  //    bus.$emit("toggleLoader", false);
                  //    console.log(error);
                  //    self.retryJoinInZoomPopup();
                  //  });
                } else {
                  bus.$emit("toggleLoader", false);
                  self.retryJoinInZoomPopup();
                }
              })
              .catch((error) => {
                bus.$emit("toggleLoader", false);
                console.log(error);
                self.retryJoinInZoomPopup();
              });
          }
        } else {
          if (IsZoomRTMP) {
            self.GoForInternalPlayer(sessionID, externalLink);
            //self.rtmpActions(0, sessionID);
          } else {
            let headers = {
              Authorization: "Bearer " + self.getSessionToken(),
              "content-type": "application/json",
            };
            let requestData = {
              email: self.email,
              name: self.name,
              first_name: self.firstName,
              last_name: self.lastName,
              webinarid: ZoomDetails.id,
              meeting_type: "webinar",
              make_speaker: false,
              //address: "",
              //phone: self.phone,
              //industry: "",
              //org: self.company,
              //job_title: self.title,
            };
            axios
              .post(APIs.AddAttendeesToZoom, requestData, {
                headers: headers,
              })
              .then((response) => {
                if (
                  response &&
                  response.data &&
                  response.data.status == 0 &&
                  response.data.data.id &&
                  response.data.data.join_url &&
                  response.data.data.join_url != ""
                ) {
                  window.open(response.data.data.join_url, "_blank");
                  self.postLeaderboardAction("SNVW");
                } else {
                  self.retryJoinInZoomPopup();
                }
              })
              .catch((error) => {
                console.log(error);
                self.retryJoinInZoomPopup();
              });
          }
        }
      } else {
        $(".tooltip").tooltip("hide");
        $(".modal").modal("hide");
        // if (
        //   screen.width < 767 &&
        //   self.AgoraPlayerBrowserSupportInMobile == false
        // ) {
        //   router.push("/screeninfo");
        // } else if (
        //   screen.width >= 768 &&
        //   screen.width <= 1024 &&
        //   self.AgoraPlayerBrowserSupportInIPad == false
        // ) {
        //   router.push("/screeninfo");
        // } else {
        self.GoForInternalPlayer(sessionID, externalLink);
        //}
      }
    },
    joinIfHasValidAuth(redirect_url) {
      if (!self.hasValidAuth({ auth_type: 1, redirect_url: redirect_url })) {
        return;
      }
    },
    getFormattedTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      minutes = minutes == 0 ? "00" : minutes;
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + amPM;
      return formattedtime;
    },
    getFormattedDateTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var day = dt.getDate();
      var month = dt.getMonth();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      minutes = minutes == 0 ? "00" : minutes;
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + amPM;
      formattedtime = monthNamesShort[month] + " " + day + ", " + formattedtime;
      return formattedtime;
    },
    Returndatetimeformat: function (seconds) {
      var dtt = "";
      dtt = new Date(seconds * 1000);
      var hours = dtt.getHours();
      var minutes =
        dtt.getMinutes().toString() == "0" ? "00" : dtt.getMinutes();
      var newformat = hours >= 12 ? "PM" : "AM";
      hours = hours >= 12 ? hours - 12 : hours;
      //var newformat = hours >= 12 ? "PM" : "AM";
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + newformat;
      return formattedtime;
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    hideModal: function () {
      this.$refs["my-modal"].hide();
    },
    toggleModal: function () {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    ShowBroadCastPg: function (SessionId) {
      $(".tooltip").tooltip("hide");
      $(".modal").modal("hide");
      if (!self.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      debugger;
      let items = self.allSessions.filter(function (item) {
        return item.SessionId == SessionId;
      });
      let session = "";
      if (items.length > 0) {
        session = items[0];
      }
      if (
        self.PlayOnDemandVideoOnPopup &&
        session &&
        session.SessionTypeDetails &&
        session.SessionTypeDetails.TypeID ==
          self.GlobalKeysData.OnDemandTypeID &&
        !session.SessionTypeDetails.ExternalVideoURL &&
        session.SessionTypeDetails.VideoURL
      ) {
        self.sessionTitle = session.Name;
        self.showVideoPlayer([session.SessionTypeDetails.VideoURL]);
        return;
      }
      let externalVideoURL = "";
      if (
        session &&
        session.SessionTypeDetails &&
        session.SessionTypeDetails.TypeID ==
          self.GlobalKeysData.OnDemandTypeID &&
        session.SessionTypeDetails.ExternalVideoURL
      ) {
        externalVideoURL = session.SessionTypeDetails.ExternalVideoURL;
      }

      self.GoForInternalPlayer(SessionId, externalVideoURL);
    },

    minimizeModal: function () {
      $("#modalOpenBroadcast").toggleClass("minimize");
      $("#modalOpenBroadcast").removeClass("maximize-window");
      $("#modalOpenBroadcast").removeClass("maximize-window");
      $("body").removeClass("modal-open");
      $(".modal-backdrop").hide();
    },
    MaximizeModal: function () {
      $("#modalOpenBroadcast").toggleClass("maximize-window");
      $("#modalOpenBroadcast").removeClass("minimize");
      $(".modal-backdrop").show();
    },
    readCookieForVideo: function (name) {
      var nameEQ = encodeURIComponent(name) + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    //getInitials: function (str) {
    //  var matches = str.match(/\b(\w)/g);
    //  var result = matches.join("");
    //  if (result.length > 2) {
    //    result = result.substring(0, 2);
    //  }
    //  return result;
    //},
    AddAnalitics: function (btnName, action) {
      var actionType = "";
      var actionLabel = "";
      if (action !== "scroll") {
        actionType = btnName.target.tagName.toLowerCase();
        if (btnName.target.getAttribute("data-tag") !== undefined) {
          if (btnName.target.getAttribute("data-tag") === null) {
            return false;
          }
          actionLabel = btnName.target.getAttribute("data-tag");

          if (actionLabel !== "") {
            analytics.AddUserAction(
              self.eventcollection,
              self.eventName,
              location.pathname,
              action,
              actionType,
              actionLabel,
              self.uid,
              self.firstName + " " + self.lastName,
              self.email
            );
          }
        }
      } else {
        analytics.AddUserAction(
          self.eventcollection,
          self.eventName,
          location.pathname,
          action,
          actionType,
          actionLabel,
          self.uid,
          self.firstName + " " + self.lastName,
          self.email
        );
      }
    },
    onClickHandler(event) {
      //this.rtmpDialog.state = true;
      // event.target is the clicked element object
      self.AddAnalitics(event, "click");
      if (self.IsZoomRTMPOptionsEnabled) {
        self.toggleMoreSessionActions("");
        //event.stopPropagation();
      }
    },
    scroll: function () {
      window.onscroll = () => {
        if (!self.IsSearchMode) {
          let bottomOfWindow =
            document.documentElement.scrollTop + window.innerHeight + 1 >=
            document.documentElement.offsetHeight;
          if (bottomOfWindow) {
            //this.AddAnalitics(event, "scroll");
          }
        }
      };
    },
    onChangeSessionStatusSuccess(sessionId, isPublished, success) {
      var msg = "";
      if (success) {
        msg = "Session " + (isPublished ? "Published" : "Unpublished");
        self.showSnackbar(msg, "info", "top");
      } else {
        msg = "Session Not " + (isPublished ? "Published" : "Unpublished");
        self.showSnackbar(msg, "error", "top");
      }
      for (var i = 0; i < self.allSessions.length; i++) {
        if (self.allSessions[i].SessionId == sessionId) {
          if (!success) {
            self.allSessions[i].IsPublished = !self.allSessions[i].IsPublished;
          }
          self.allSessions[i].IsStatusChanging = false;
          break;
        }
      }
    },
    requestConfirmDeleteSession(sessionId) {
      self.selectedSessionId = sessionId;
      self.showDeleteConfirmDialog = true;
    },
    onConfirmDeleteSession(confirm) {
      self.showDeleteConfirmDialog = false;
      if (confirm) {
        //bus.$emit("toggleLoader", true);
        for (var i = 0; i < self.allSessions.length; i++) {
          if (self.allSessions[i].SessionId == self.selectedSessionId) {
            self.allSessions[i].IsDeleting = true;
            break;
          }
        }
        self.$parent.deleteSession(self.selectedSessionId);
      }
    },
    onDeleteSessionSuccess(sessionId, success) {
      //bus.$emit("toggleLoader", false);
      var msg = "";
      if (success) {
        msg = "Session Deleted";
        self.showSnackbar(msg, "info", "top");
        self.allSessions = self.allSessions.filter(function (item) {
          return item.SessionId != sessionId;
        });
        self.setupCurrentTabs();
      } else {
        msg = "Session Not Deleted";
        self.showSnackbar(msg, "error", "top");
        for (var i = 0; i < self.allSessions.length; i++) {
          if (self.allSessions[i].SessionId == sessionId) {
            self.allSessions[i].IsDeleting = false;
            break;
          }
        }
      }
    },
    openSpeakerDetails(attendeeId) {
      self.attendeeData = [];
      var listRef = db
        .collection(self.eventcollection)
        .doc("SpeakerList")
        .collection("Speakers")
        .where("SpeakerId", "==", attendeeId);
      listRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          self.attendeeData.push({
            id: doc.id,
            Name:
              (doc.data().FirstName == undefined ? "" : doc.data().FirstName) +
              " " +
              (doc.data().LastName == undefined ? "" : doc.data().LastName),
            Email: doc.data().Email,
            Image: doc.data().ProfilePictureURL,
            Company: doc.data().Company,
            Designation: doc.data().Designation,
            Profile: doc.data().Profile == undefined ? "" : doc.data().Profile,
            Resources: doc.data().Resources ? doc.data().Resources : [],
            SocialLinks: doc.data().SocialLinks ? doc.data().SocialLinks : [],
            Initials: common.getInitials(
              (doc.data().FirstName == undefined ? "" : doc.data().FirstName) +
                " " +
                (doc.data().LastName == undefined ? "" : doc.data().LastName)
            ),
            //ShowSearch: self.ShowSearch
            Phone: doc.data().Phone,
          });
        });
        document.getElementById("spnSpkEmail").innerText =
          self.attendeeData[0].Email;
        document.getElementById("spnSpkPhone").innerText =
          self.attendeeData[0].Phone;

        document.getElementById("Session").innerText = "";
        if (
          self.attendeeData[0].Image != null &&
          self.attendeeData[0].Image != ""
        ) {
          $("#imgModalSpeakers").attr("src", self.attendeeData[0].Image);
          document.getElementById("dvImgeHldText").innerText = "";
          $("#dvImgeHldText").hide();
          $("#imgModalSpeakers").show();
          $("#dvImgeHld").show();
        } else {
          $("#imgModalSpeakers").attr("src", "");
          $("#imgModalSpeakers").hide();

          document.getElementById("dvImgeHldText").innerText =
            self.attendeeData[0].Initials;
          $("#dvImgeHldText").show();
          $("#dvImgeHld").hide();
        }
        document.getElementById("modalName").innerText =
          self.attendeeData[0].Name;
        document.getElementById("modalCompany").innerText =
          self.attendeeData[0].Company;
        document.getElementById("modalTtile").innerText =
          self.attendeeData[0].Designation;
        document.getElementById("modalProfile").innerHTML =
          self.attendeeData[0].Profile;
        //--------------Resource collection-------------------------------------------------------------
        document.getElementById("SpkModalResource").innerText = "";
        if (self.attendeeData[0].Resources != undefined) {
          if (self.attendeeData[0].Resources.length > 0) {
            self.attendeeData[0].Resources.forEach((resource) => {
              if (resource != "") {
                $("#SpkModalResource").append(
                  " <div class='session-tab-innerBox p-3 mb-2'><h5 class><a href=" +
                    resource +
                    '" target="_blank">' +
                    self.getFileName(resource) +
                    "</h5></div>"
                );
              }
            });
            document.getElementById("ulTabList").children[2].style.display =
              "block";
          } else {
            document.getElementById("ulTabList").children[2].style.display =
              "none";
          }
        } else {
          document.getElementById("ulTabList").children[2].style.display =
            "none";
        }

        // $("#myModal2").addClass("show");
        // $("#myModal2").show();
        $("#myModal2").modal("show");
        //-------------Session collection for Speaker-------------------------------------
        var arrSession = [];
        var listRef = db
          .collection(self.eventcollection)
          .doc("SessionList")
          .collection("Sessions");
        listRef
          .orderBy("StartDate", "desc")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var mappedSpeakers = doc.data().MappedSpeakers;

              $.each(mappedSpeakers, function (index, value) {
                if (value.AttendeeId != undefined) {
                  if (value.AttendeeId == attendeeId) {
                    var obj = new Object();
                    obj.Name =
                      doc.data().Name == undefined ? "" : doc.data().Name;
                    obj.StartDate =
                      doc.data().StartDate == undefined
                        ? ""
                        : doc.data().StartDate;
                    obj.EndDate =
                      doc.data().EndDate == undefined ? "" : doc.data().EndDate;
                    arrSession.push(obj);
                  }
                }
              });
            });
            var dtt;
            var dttEnd;
            $.each(arrSession, function (index, value) {
              var AtartdateString = "";
              var endDateString = "";

              const monthNamesShort = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
              ];
              //----------------------------------------------------------------------------------
              dtt = new Date(value.StartDate.seconds * 1000);
              var minutes = dtt.getMinutes();
              minutes = minutes == 0 ? "00" : minutes;
              if (minutes != "00" && parseInt(minutes) < 10) {
                minutes = "0" + minutes;
              }

              AtartdateString +=
                monthNamesShort[dtt.getMonth()] +
                " " +
                dtt.getDate() +
                " " +
                dtt.getHours() +
                ":" +
                minutes;
              //----------------------------------------------------------------------------------
              dttEnd = new Date(value.EndDate.seconds * 1000);
              var endMins = dttEnd.getMinutes();
              var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

              endMins = endMins == 0 ? "00" : endMins;
              if (endMins != "00" && parseInt(endMins) < 10) {
                endMins = "0" + endMins;
              }
              endDateString +=
                monthNamesShort[dttEnd.getMonth()] +
                " " +
                dttEnd.getDate() +
                " " +
                dttEnd.getHours() +
                ":" +
                endMins;
              //----------------------------------------------------------------------------------
              $("#Session").append(
                " <div class='session-tab-innerBox p-3 mb-2'><h5 class>" +
                  value.Name +
                  "</h5><p class='event-date'>" +
                  AtartdateString +
                  " to " +
                  endDateString +
                  " " +
                  timeZone +
                  "</p></div>"
              );
            });
          });
        $("#spnFacebook").hide();
        $("#spnTwitter").hide();
        $("#spnLinkedIn").hide();
        console.log(self.attendeeData[0].SocialLinks);
        var showFB = 0;
        var showTwitter = 0;
        var showLinkedIn = 0;

        self.attendeeData[0].SocialLinks.forEach((sLink) => {
          if (sLink["Facebook"] != undefined) {
            if (sLink["Facebook"] != "") {
              showFB++;
              if (sLink["Facebook"].includes("https://")) {
                document.getElementById("anchFacebook").href =
                  sLink["Facebook"];
              } else {
                document.getElementById("anchFacebook").href =
                  "https://" + sLink["Facebook"];
              }
            }
          }

          if (sLink["Twitter"] != undefined) {
            if (sLink["Twitter"] != "") {
              showTwitter++;
              if (sLink["Twitter"].includes("https://")) {
                document.getElementById("anchTwitter").href = sLink["Twitter"];
              } else {
                document.getElementById("anchTwitter").href =
                  "https://" + sLink["Twitter"];
              }
            }
          }

          if (sLink["LinkedIn"] != undefined) {
            if (sLink["LinkedIn"] != "") {
              showLinkedIn++;
              if (sLink["LinkedIn"].includes("https://")) {
                document.getElementById("anchLinkedIn").href =
                  sLink["LinkedIn"];
              } else {
                document.getElementById("anchLinkedIn").href =
                  "https://" + sLink["LinkedIn"];
              }
            }
          }
        });
        if (showFB > 0) {
          $("#spnFacebook").show();
        }
        if (showTwitter > 0) {
          $("#spnTwitter").show();
        }
        if (showLinkedIn > 0) {
          $("#spnLinkedIn").show();
        }
      });
    },
  },
};
</script>
<style scoped>
.page-head {
  font-size: 24px !important;
  font-weight: 700 !important;
}
</style>
